import { createContext, useContext, useState, useEffect } from 'react';

// ─── Translations ────────────────────────────────────────────────────────────

const translations = {

  // ── FRANÇAIS ───────────────────────────────────────────────────────────────
  fr: {
    nav: {
      services: 'Expertises',
      projects: 'Réalisations',
      forSale:  'En vente',
      about:    'Notre histoire',
      news:     'Actualités',
      contact:  'Contact',
      cta:      'Devis gratuit',
    },
    hero: {
      label:    "Platja d'Aro · Costa Brava",
      title:    ['Construire', "l'essentiel."],
      subtitle: "Une entreprise de construction allemande, installée sur la Costa Brava. Un interlocuteur, un planning tenu, un chantier suivi de bout en bout.",
      cta1:     'Découvrir nos projets',
      cta2:     'Devis gratuit',
      scroll:   'Défiler',
    },
    stats: [
      { value: '100+', label: 'Projets réalisés'     },
      { value: '5',    label: "Années d'expertise"   },
      { value: '4',    label: 'Langues parlées'       },
      { value: '100%', label: 'Recommandations'       },
    ],
    story: {
      label:  'Notre histoire',
      quote:  "Ce qui me guide depuis toujours, c'est de comprendre ce que le client veut vraiment, puis de le livrer dans les temps.",
      author: '— Sebastian Lemke, fondateur',
      title:  "L'exigence automobile,\nappliquée à votre maison.",
      p1:     "Avant la Costa Brava, Sebastian Lemke a passé des années dans les grandes maisons automobiles allemandes. Une école exigeante, où l'on apprend à livrer dans les délais et sans approximation. Puis la région l'a retenu.",
      p2:     "Il s'installe à Platja d'Aro et fonde Construcciones Remalex S.L. autour d'une idée simple : on doit construire une maison avec le même soin qu'une voiture de série haut de gamme.",
      cta:    'Notre histoire complète',
    },
    services: {
      label:   'Nos expertises',
      title:   'Six métiers, une équipe',
      viewAll: 'Voir tous nos services',
      items: [
        { name: 'Construction neuve',      desc: "Villas sur mesure, de la première esquisse à la remise des clés.",                link: '/services/construction' },
        { name: 'Rénovation',              desc: "Transformation complète ou partielle, sans dénaturer le bâti existant.",          link: '/services/renovation'   },
        { name: 'Aménagement intérieur',   desc: 'Menuiseries sur mesure, finitions soignées, domotique intégrée.',                 link: '/services/interieur'    },
        { name: 'Espaces extérieurs',      desc: 'Jardins, terrasses et éclairage pensés comme un prolongement du salon.',          link: '/services/exterieur'    },
        { name: 'Piscines',                desc: 'À débordement, naturelles ou automatisées : chaque projet est dessiné pour le terrain.',  link: '/services/piscine'      },
        { name: 'Maçonnerie de pierre',    desc: "Pierre catalane travaillée à la main. Voûtes, murs porteurs, escaliers.",         link: '/services/maconnerie'   },
      ],
    },
    partnership: {
      label: 'Écosystème complet',
      title: 'Construire, gérer, valoriser.',
      desc:  "Nous travaillons en partenariat exclusif avec Solenca, qui prend le relais une fois la maison livrée : gestion locative, conciergerie, entretien. Construcciones Remalex bâtit, Solenca s'occupe de la suite. Un seul écosystème pour un investissement sur la Costa Brava.",
      tag1:  'Construction & Rénovation',
      tag2:  'Property Management',
      cta:   'Découvrir Solenca',
    },
    testimonial: {
      quote:    "Sebastian et son équipe ont transformé notre mas catalan en une vraie villa de famille. La rigueur allemande, posée sur du bâti catalan : on n'imaginait pas un résultat à ce niveau.",
      author:   'Thomas & Anna H.',
      location: "Platja d'Aro · Clients depuis 2022",
    },
    cta: {
      title:    'Un projet en tête ?',
      subtitle: "Le premier échange est gratuit. On en discute autour d'un café à Platja d'Aro, ou par téléphone si vous êtes loin.",
      btn1:     'Nous contacter',
      btn2:     '+34 602 645 005',
    },
    footer: {
      tagline:      'Your house in our care.',
      servicesTitle:'Expertises',
      navTitle:     'Navigation',
      contactTitle: 'Contact',
      address:      "Carrer dels Avets 5\nCastell d'Aro, Gérone",
      hours:        'Lun – Dim : 9h00 – 17h00',
      legal:        'Mentions légales',
      privacy:      'Confidentialité',
      cookies:      'Cookies',
      rights:       'Tous droits réservés.',
      developedBy:  'Développé par',
      adminTooltip: 'Espace administration',
      adminLabel:   'Admin',
      navLinks: [
        { label: 'Accueil',         to: '/'                  },
        { label: 'Expertises',      to: '/services'          },
        { label: 'Réalisations',    to: '/realisations'      },
        { label: 'En vente',        to: '/projets-en-vente'  },
        { label: 'Notre histoire',  to: '/a-propos'          },
        { label: 'Partenaires',     to: '/partenaires'       },
        { label: 'Contact',         to: '/contact'           },
      ],
    },
    about: {
      heroLabel:   'À propos',
      heroTitle:   "Bâtir l'essentiel.",
      heroSub:     "Construcciones Remalex S.L., construction et rénovation sur la Costa Brava depuis 2021.",
      storyLabel:  'Notre ADN',
      storyTitle:  "La rigueur allemande,\nau service de l'habitat espagnol.",
      storyP1:     "Avant de poser ses valises sur la Costa Brava, Sebastian Lemke a fait sa carrière dans les grands groupes automobiles allemands. Il y est entré par le terrain et en a gravi tous les échelons, jusqu'à devenir une figure reconnue de la vente dans le secteur. Sa qualité première : savoir entendre ce qu'un client cherche vraiment, parfois avant qu'il sache le formuler.",
      storyP2:     "En 2021, il fonde son entreprise de construction à Platja d'Aro. L'idée est simple : appliquer en Espagne les méthodes de travail qu'il connaît. Il s'entoure d'artisans installés dans la région et tient une règle stricte, le respect des délais annoncés.",
      storyP3:     "En 2026, la société se réorganise. CasaCare Remalex devient Construcciones Remalex S.L., et la branche maintenance passe chez Solenca, partenaire de longue date. Sebastian peut alors se concentrer sur ce qui l'intéresse depuis le début, la construction et la rénovation.",
      valuesLabel: 'Nos valeurs',
      valuesTitle: 'Ce qui nous guide',
      values: [
        { num: '01', title: 'Exigence',     desc: "On applique au bâtiment les méthodes d'une chaîne de production allemande : tolérances serrées, contrôle à chaque étape, rien ne quitte le chantier à moitié fait." },
        { num: '02', title: 'Proximité',    desc: 'Sebastian suit lui-même chaque chantier. Un seul interlocuteur, joignable en français, allemand, anglais ou espagnol.' },
        { num: '03', title: 'Confiance',    desc: 'Devis détaillés, planning partagé, factures fournisseurs sur demande. Vous savez où va chaque euro.' },
        { num: '04', title: 'Respect',      desc: "Respect du lieu, du bâti déjà là, de vos goûts et du paysage catalan dans lequel s'inscrit la maison." },
      ],
      founderLabel: 'Le fondateur',
      founderTitle: 'Dr. h.c. Sebastian Lemke',
      founderRole:  'Fondateur & Directeur général',
      founderBio1:  "Sebastian Lemke a fait toute sa carrière commerciale dans les grands constructeurs automobiles allemands, jusqu'à devenir l'une des figures reconnues du secteur. Sa force : comprendre vite ce que cherche son interlocuteur et lui apporter une réponse concrète, sans baratin.",
      founderBio2:  "Polyglotte (allemand, français, espagnol, anglais), il a importé sur la Costa Brava la méthode de l'industrie automobile : planning serré, contrôle qualité à chaque étape, livraison à la date prévue. Il s'appuie sur un noyau d'artisans locaux qu'il connaît et avec qui il travaille depuis plusieurs années.",
      timelineLabel:'Notre histoire',
      timelineTitle:'Cinq ans de chantiers',
      timeline: [
        { year: '2021', title: 'Fondation',              desc: "Sebastian Lemke fonde CasaCare Remalex à Platja d'Aro. L'idée : appliquer au marché catalan les méthodes de travail allemandes." },
        { year: '2022', title: 'Premiers succès',        desc: "Les premiers chantiers livrés font parler d'eux. La clientèle internationale, exigeante, recommande l'entreprise par bouche-à-oreille." },
        { year: '2023', title: 'Partenariat Solenca',    desc: "Mise en place du partenariat stratégique avec Solenca, qui prend en charge la gestion locative et la conciergerie une fois la maison livrée." },
        { year: '2024', title: 'Expansion',              desc: "L'équipe grandit avec de nouveaux artisans recrutés dans la région. La société mène en parallèle des constructions neuves et des rénovations lourdes." },
        { year: '2025', title: '100+ projets',           desc: "Le cap des cent chantiers livrés est franchi. Remalex s'installe comme une référence locale pour la construction et la rénovation." },
        { year: '2026', title: 'Construcciones Remalex', desc: "Réorganisation : la branche maintenance est transférée à Solenca, et la société est renommée Construcciones Remalex S.L. Sebastian se concentre sur la construction et la rénovation." },
      ],
      certifLabel: 'Certifications & garanties',
      certifs: [
        { title: 'Assurance RC Professionnelle', desc: 'Couverture complète de nos chantiers'   },
        { title: 'Registre Officiel Espagnol',   desc: 'Entreprise enregistrée et certifiée'    },
        { title: 'NIF Espagnol',                 desc: 'Conformité fiscale totale'               },
      ],
      ctaTitle: 'Parlons de votre projet',
      ctaBtn:   'Nous contacter',
    },
    contact: {
      heroLabel: 'Contact',
      heroTitle: 'Parlons de votre projet.',
      heroSub:   "Le premier échange est gratuit. Nous répondons en français, anglais, allemand et espagnol.",
      infoTitle: 'Nous trouver',
      form: {
        name:         'Prénom & Nom',
        email:        'Email',
        phone:        'Téléphone',
        projectType:  'Type de projet',
        budget:       'Budget estimé',
        message:      'Décrivez votre projet',
        privacy:      "J'accepte que mes données soient utilisées pour répondre à ma demande.",
        submit:       'Envoyer ma demande',
        success:      'Votre message a bien été envoyé !',
        successSub:   'Nous vous répondons sous 24h.',
        projectTypes: [
          { value: 'newBuild',    label: 'Construction neuve' },
          { value: 'renovation',  label: 'Rénovation'         },
          { value: 'pool',        label: 'Piscine'            },
          { value: 'outdoor',     label: 'Espaces extérieurs' },
          { value: 'other',       label: 'Autre'              },
        ],
        budgets: [
          { value: '50-100',  label: '50 000 € – 100 000 €'   },
          { value: '100-250', label: '100 000 € – 250 000 €'  },
          { value: '250-500', label: '250 000 € – 500 000 €'  },
          { value: '500+',    label: '500 000 € +'            },
        ],
      },
    },
    contactPage: {
      addressLabel:    'Adresse',
      phoneLabel:      'Téléphone',
      hoursLabel:      'Horaires',
      languagesLabel:  'Langues',
      address:         "Carrer dels Avets, 5\n17250 Castell d'Aro, Girona\nCosta Brava, España",
      required:        '* requis',
      emailPlaceholder:'votre@email.com',
      phonePlaceholder:'600 000 000',
      newRequest:      'Nouvelle demande',
      errorGeneric:    'Une erreur est survenue.',
    },
    partnersPage: {
      heroLabel:    'Réseau',
      heroTitle:    'Nos Partenaires.',
      heroSub:      "Construcciones Remalex travaille avec quelques acteurs sélectionnés sur la Costa Brava pour couvrir toute la chaîne, de l'achat au foncier jusqu'à la gestion du bien.",
      ctaLabel:     'Votre projet',
      visitWebsite: 'Visiter le site',
      categories: {
        solenca:    'Maintenance & Property Management',
        lucasFox:   'Agence immobilière premium',
      },
    },
    newsPage: {
      title:       'Actualités',
      subtitle:    'Les dernières nouvelles de Construcciones Remalex',
      readMore:    'Lire la suite',
      backToList:  'Retour aux actualités',
      publishedOn: 'Publié le',
      empty:       "Aucun article pour l'instant.",
    },
    servicesPage: {
      hero: {
        label:    'Nos Expertises',
        title:    "Six métiers sous un même toit.",
        subtitle: "De la construction neuve à la rénovation lourde, on coordonne tous les corps d'état nécessaires à votre chantier sur la Costa Brava, sans sous-traiter le pilotage.",
      },
      learnMore: 'En savoir plus',
      partnership: {
        label:     'Partenariat exclusif',
        title:     'Construire et gérer, sous un même toit.',
        desc:      "Solenca, agence immobilière de la Costa Brava, prend le relais une fois la maison livrée : gestion locative, conciergerie, entretien. Construcciones Remalex bâtit, Solenca s'occupe du reste. Un interlocuteur côté construction, un côté gestion.",
        ecosystem: 'Écosystème complet',
        tagBadge:  'Construction + Gestion',
        cta:       'Découvrir Solenca',
      },
      cta: {
        label:    'Votre projet',
        title:    'On en parle ?',
        subtitle: "Un premier rendez-vous, sans engagement, pour qu'on comprenne ce que vous avez en tête et qu'on voie si on peut vous aider.",
        btn:      'Nous contacter',
      },
      services: [
        { id: 'construction', num: '01', title: 'Construction Neuve',     tag: 'Villas sur mesure',       description: "Des villas pensées pour leur terrain : orientation, vues, lumière, intégration dans le paysage de la Costa Brava. Architecture contemporaine, vocabulaire méditerranéen.", features: ['Architecture sur mesure', 'Matériaux sélectionnés', 'Suivi personnalisé de Sebastian'], image: '/images/new-construction.webp' },
        { id: 'renovation',   num: '02', title: 'Rénovation',             tag: 'Transformation complète', description: "Rénover sans dénaturer. Appartements, villas, maisons de ville : on garde ce qui fait l'âme du lieu et on remet à niveau le reste (isolation, réseaux, finitions).", features: ['Diagnostic complet', 'Gestion de chantier complète', 'Coordination des artisans'], image: '/images/renovation.webp' },
        { id: 'masia',        num: '03', title: 'Rénovation de Masia',    tag: 'Patrimoine catalan',      description: "C'est notre spécialité. La masia catalane se rénove avec ses propres règles : pierres apparentes, voûtes, poutres anciennes. On les conserve, et on injecte le confort actuel par-dessus.", features: ['Respect du patrimoine bâti', 'Techniques traditionnelles', 'Confort moderne intégré'], image: '/images/renovation-masia.webp' },
        { id: 'piscine',      num: '04', title: 'Piscines',               tag: 'Design & Technique',      description: "Piscines dessinées pour leur terrain : effet miroir, lagon naturel, bassin chauffé. Chaque projet tient compte du sol, du vent et du climat local.", features: ['Design personnalisé', 'Système de filtration dernière génération', 'Intégration paysagère'], image: '/images/pool.webp' },
        { id: 'exterieur',    num: '05', title: 'Aménagement Extérieur',  tag: 'Jardins & Terrasses',     description: "Terrasses, jardins, allées, coins repas extérieurs : on prolonge la maison vers le paysage catalan, plutôt que d'opposer les deux.", features: ['Conception paysagère', 'Pavage et terrasse sur mesure', 'Éclairage architectural'], image: '/images/garden-amenagement.webp' },
        { id: 'maintenance',  num: '06', title: 'Maintenance',            tag: 'Suivi & Sérénité',        description: "Avec Solenca, notre partenaire spécialisé dans la gestion immobilière sur la Costa Brava, on prend en charge l'entretien courant : plomberie, électricité, jardinage, piscine, conciergerie. Vous gardez un seul contact.", features: ['Partenariat exclusif avec Solenca', 'Contrats annuels sur mesure', 'Gestion locative & conciergerie'], image: '/solenca-van.webp' },
      ],
    },
    projectsPage: {
      hero: {
        label:    'Réalisations',
        title1:   'Nos',
        titleItalic: 'projets.',
        subtitle: "Une sélection de chantiers livrés ces dernières années : constructions neuves, rénovations de masia, piscines, aménagements extérieurs.",
      },
      categories: [
        { id: 'all',       label: 'Tous'         },
        { id: 'newBuild',  label: 'Construction'  },
        { id: 'renovation',label: 'Rénovation'    },
        { id: 'pool',      label: 'Piscines'      },
        { id: 'outdoor',   label: 'Extérieur'     },
      ],
      typeLabels: {
        newBuild:  'Construction',
        renovation:'Rénovation',
        pool:      'Piscine',
        outdoor:   'Extérieur',
        masonry:   'Maçonnerie',
      },
      noResults: 'Aucun projet dans cette catégorie.',
    },
    legalPage: {
      label: 'Légal',
      mentionsTitle: 'Mentions légales',
      privacyTitle:  'Politique de confidentialité',
    },
    servicePages: {
      breadcrumbBase: 'Services',
      ourAssets: 'Nos Atouts',
      ourServices: 'Nos Formules',
      ourWork: 'Nos Réalisations',
      yourProject: 'Votre projet',
      ctaTitle: 'Discutons de votre projet',
      ctaBtn: 'Demander un devis',
      construction: {
        breadcrumb: 'Construction Neuve',
        heroLabel:  'Construction Neuve',
        heroTitle1: 'Maisons',
        heroTitleItalic: 'pensées sur mesure',
        heroSubtitle: "Une villa, c'est d'abord un terrain. On conçoit la maison autour : son orientation, ses vues, ses matériaux. Architecture contemporaine méditerranéenne, finitions soignées.",
        heroCta:    'Démarrer mon projet',
        featuresLabel: 'Nos Atouts',
        featuresTitle: 'Notre méthode, étape par étape',
        processLabel: 'Processus',
        processTitle: "De l'idée à la livraison",
        ctaSubtitle: "Premier rendez-vous gratuit. Nous regardons votre terrain et discutons des premières pistes ensemble.",
        features: [
          { title: 'Architecture sur mesure',  description: "Plans dessinés pour votre terrain et votre façon de vivre. Pas de modèle dupliqué d'un chantier à l'autre." },
          { title: 'Matériaux premium',        description: "Pierre naturelle, bois certifié, acier inoxydable : on sélectionne les matériaux avec vous, fournisseur par fournisseur." },
          { title: 'Équipe intégrée',          description: "Architectes, ingénieurs et artisans coordonnés en interne, sans renvoi de balle entre prestataires." },
          { title: 'Garantie décennale',       description: "Garantie décennale à la livraison, conforme au droit espagnol. Le chantier est couvert pendant dix ans." },
        ],
        process: [
          { num: '01', title: 'Étude du terrain',           desc: "Analyse topographique, étude de sol, contraintes urbanistiques." },
          { num: '02', title: 'Conception architecturale',  desc: "Plans 3D, choix des matériaux, optimisation énergétique." },
          { num: '03', title: 'Permis et démarches',        desc: "Gestion complète des autorisations administratives." },
          { num: '04', title: 'Construction',               desc: "Suivi de chantier avec points d'étape réguliers et photos hebdomadaires." },
          { num: '05', title: 'Livraison',                  desc: "Inspection finale et remise des clés de votre villa." },
        ],
      },
      renovation: {
        breadcrumb: 'Rénovation',
        heroLabel:  'Rénovation',
        heroTitle1: 'Transformer,',
        heroTitleItalic: 'sans dénaturer',
        heroSubtitle: "Une rénovation réussie garde ce qui fait le caractère du lieu et remet à niveau le reste : isolation, réseaux, lumière, agencement. Des mas catalans aux villas contemporaines.",
        heroCta:    'Évaluer mon projet',
        featuresLabel: 'Nos Atouts',
        featuresTitle: 'Pourquoi nous choisir',
        typesLabel:  'Nos Formules',
        typesTitle:  'Solutions adaptées',
        ctaSubtitle: "Diagnostic gratuit, estimation détaillée. On se déplace pour voir le bien et en discuter sur place.",
        features: [
          { title: 'Diagnostic complet',        description: "Évaluation de la structure, des installations et du potentiel de transformation, avant tout chiffrage." },
          { title: 'Optimisation énergétique',  description: "Isolation, ventilation, panneaux solaires : on baisse les factures et on gagne en confort." },
          { title: 'Valorisation patrimoniale', description: "Restauration des éléments d'origine sans les figer : voûtes catalanes, murs en pierre, tomettes." },
          { title: 'Modernisation intelligente',description: "Intégration discrète des équipements actuels : domotique, climatisation, sécurité." },
        ],
        types: [
          { title: 'Rénovation complète', desc: "Reprise intégrale, de la structure aux finitions." },
          { title: 'Rénovation partielle',desc: "Travaux ciblés : cuisine, salles de bain, pièces de vie." },
          { title: 'Extension',           desc: "Agrandissement raccordé proprement au bâti existant." },
        ],
      },
      exterieur: {
        breadcrumb: 'Aménagement Extérieur',
        heroLabel:  'Aménagement Extérieur',
        heroTitle1: 'Jardins &',
        heroTitleItalic: 'terrasses',
        heroSubtitle: "Un extérieur bien pensé prolonge la maison vers le paysage catalan. Nous dessinons jardins et terrasses adaptés au climat méditerranéen, à l'eau qui s'y fait rare l'été, et à votre rythme de vie.",
        heroCta:    'Imaginer mon jardin',
        featuresLabel: 'Nos Atouts',
        featuresTitle: 'Un jardin sur mesure',
        galleryLabel: 'Nos Réalisations',
        galleryTitle: 'Quelques réalisations',
        ctaSubtitle: "Consultation paysagère gratuite. On se déplace pour voir votre extérieur et en discuter sur place.",
        services: [
          { title: 'Conception paysagère',  description: "Jardins méditerranéens, plantations choisies pour résister aux étés secs de la Costa Brava.", items: ["Plans paysagers 3D", "Sélection végétale", "Systèmes d'irrigation"] },
          { title: 'Éclairage architectural',description: "Mise en lumière discrète du jardin et de la façade, sans pollution lumineuse.", items: ["LED basse consommation", "Scénarios lumineux", "Automatisation"] },
          { title: 'Terrasses & pergolas',  description: "Espaces de vie extérieurs conçus pour le climat méditerranéen : ombre l'été, soleil l'hiver.", items: ["Bois exotique certifié", "Pierre naturelle", "Pergolas bioclimatiques"] },
          { title: "Gestion de l'eau",      description: "Solutions durables pour l'arrosage et la récupération d'eau, indispensables sur la côte catalane.", items: ["Récupération eau de pluie", "Arrosage intelligent", "Fontaines & bassins"] },
        ],
      },
      interieur: {
        breadcrumb: 'Design Intérieur',
        heroLabel:  'Design Intérieur',
        heroTitle1: 'Intérieurs',
        heroTitleItalic: 'au cordeau',
        heroSubtitle: "Un intérieur qui fonctionne avant d'être beau. Menuiseries sur mesure, revêtements choisis fournisseur par fournisseur, domotique discrète : on travaille les détails, parce que ce sont eux qu'on vit au quotidien.",
        heroCta:    'Concevoir mon intérieur',
        featuresLabel: 'Nos Atouts',
        featuresTitle: 'Le souci du détail',
        roomsLabel:  'Nos Formules',
        roomsTitle:  'Pièces sur mesure',
        galleryLabel: 'Nos Réalisations',
        galleryTitle: 'Quelques inspirations',
        ctaSubtitle: "Consultation design gratuite. Apportez vos références, on en discute ensemble.",
        services: [
          { title: 'Menuiseries sur mesure', description: "Portes, fenêtres, placards et dressings conçus et fabriqués pour votre intérieur, pièce par pièce.", items: ["Bois massif & MDF", "Design contemporain ou classique", "Finitions laquées ou naturelles"] },
          { title: 'Revêtements premium',    description: "Sols, murs et plafonds en matériaux nobles, choisis pour durer.", items: ["Parquet massif & contrecollé", "Pierre naturelle & carrelage", "Enduits décoratifs"] },
          { title: 'Domotique intégrée',     description: "Systèmes pilotés pour le confort et la sécurité, intégrés sans envahir l'espace visuel.", items: ["Éclairage automatisé", "Climatisation zonée", "Sécurité connectée"] },
          { title: 'Finitions soignées',     description: "Ce sont les détails qui font la différence sur le long terme : raccords propres, jonctions invisibles, peinture sans défaut.", items: ["Peintures écologiques", "Staffs et moulures", "Éclairage architectural"] },
        ],
        rooms: [
          { name: 'Cuisines',      desc: "Design italien, équipements professionnels" },
          { name: 'Salles de bain',desc: "Spa privé, robinetterie design" },
          { name: 'Dressings',     desc: "Organisation sur mesure, éclairage intégré" },
          { name: 'Escaliers',     desc: "Bois, métal ou verre selon le projet" },
        ],
      },
      maconnerie: {
        breadcrumb: 'Maçonnerie',
        heroLabel:  'Maçonnerie',
        heroTitle1: "L'art de",
        heroTitleItalic: 'la pierre',
        heroSubtitle: "Notre équipe de maçons travaille la pierre comme on l'a toujours fait dans la région, avec les outils d'aujourd'hui. Pierre naturelle, voûtes catalanes, enduits à la chaux : un savoir-faire qui se transmet sur les chantiers, pas dans les brochures.",
        heroCta:    'Discuter de mon projet',
        techniquesLabel: 'Nos Formules',
        techniquesTitle: 'Techniques traditionnelles',
        servicesLabel:   'Nos Atouts',
        servicesTitle:   'De la fondation aux finitions',
        commitmentTitle: 'Notre engagement',
        commitmentDesc:  "Nos chantiers de maçonnerie sont menés par nos équipes internes, formées aux techniques traditionnelles catalanes et aux normes en vigueur.",
        ctaSubtitle: "Consultation gratuite, devis détaillé. Nos équipes se déplacent pour étudier votre projet.",
        techniques: [
          { title: 'Pierre naturelle',    description: "Murs en pierre sèche, parement, opus incertum. Nous travaillons les pierres locales de Gérone, livrées par des carrières que nous connaissons." },
          { title: 'Voûtes catalanes',    description: "Technique de construction en briques posées à plat, signature de l'architecture méditerranéenne. Peu d'équipes la maîtrisent encore, la nôtre oui." },
          { title: 'Béton décoratif',     description: "Béton ciré, béton imprimé, béton désactivé pour vos sols et murets." },
        ],
        services: ['Fondations et structure', 'Murs porteurs et cloisons', 'Escaliers en pierre', 'Cheminées et barbecues', 'Murets et clôtures', 'Restauration de façades', 'Enduits traditionnels', 'Joints de pierre apparente'],
        commitments: ['Matériaux sourcés localement quand possible', 'Respect des techniques traditionnelles catalanes', 'Garantie décennale sur tous nos travaux'],
      },
      piscine: {
        breadcrumb: 'Piscines',
        heroLabel:  'Piscines',
        heroTitle1: "L'art de",
        heroTitleItalic: "l'eau",
        heroSubtitle: "Piscines dessinées pour s'inscrire dans le terrain et la maison, plutôt que posées dessus. Du dessin initial aux équipements techniques, on pilote l'ensemble.",
        heroCta:    'Concevoir ma piscine',
        featuresLabel: 'Nos Atouts',
        featuresTitle: 'Technologies & Design',
        typesLabel:  'Nos Formules',
        typesTitle:  'Choisissez votre style',
        galleryLabel: 'Nos Réalisations',
        galleryTitle: 'Quelques réalisations',
        ctaSubtitle: "Étude de faisabilité gratuite. On analyse votre terrain et ce que vous avez en tête.",
        features: [
          { title: 'Piscine à débordement', description: "Effet miroir intégré au paysage méditerranéen, calibré pour votre vue." },
          { title: 'Chauffage solaire',     description: "Pour prolonger la saison de baignade sans alourdir la facture énergétique." },
          { title: 'Traitement naturel',    description: "Alternatives au chlore : sel, UV, ou bassins biologiques pour une eau plus douce." },
          { title: 'Automatisation complète',description: "Filtration, chauffage, éclairage pilotés à distance depuis votre téléphone." },
        ],
        types: [
          { title: 'Piscine traditionnelle', desc: "Construction en béton armé, dimensions personnalisées, finition carrelage ou liner.", size: '8×4 m' },
          { title: 'Piscine à débordement',  desc: "Effet miroir et continuité visuelle avec le paysage.", size: '10×5 m' },
          { title: 'Piscine biologique',     desc: "Bassin naturel avec zone de régénération végétale.", size: '12×6 m' },
        ],
      },
    },
  },

  // ── ENGLISH ────────────────────────────────────────────────────────────────
  en: {
    nav: {
      services: 'Expertise',
      projects: 'Projects',
      forSale:  'For sale',
      about:    'Our story',
      news:     'News',
      contact:  'Contact',
      cta:      'Free quote',
    },
    hero: {
      label:    'Platja d\'Aro · Costa Brava',
      title:    ['Building', 'what matters.'],
      subtitle: 'A German construction firm based on the Costa Brava. One point of contact, a schedule that holds, a project followed from start to finish.',
      cta1:     'Discover our projects',
      cta2:     'Free quote',
      scroll:   'Scroll',
    },
    stats: [
      { value: '100+', label: 'Completed projects' },
      { value: '5',    label: 'Years of expertise' },
      { value: '4',    label: 'Languages spoken'   },
      { value: '100%', label: 'Recommendations'    },
    ],
    story: {
      label:  'Our story',
      quote:  'What has always guided me is understanding what the client truly wants, then delivering it on time.',
      author: '— Sebastian Lemke, founder',
      title:  'Automotive standards,\napplied to your home.',
      p1:     'Before the Costa Brava, Sebastian Lemke spent years in the major German car manufacturers. A demanding school, where you learn to deliver on schedule and without approximation. Then the region kept him.',
      p2:     'He settled in Platja d\'Aro and founded Construcciones Remalex S.L. around one simple idea: a house should be built with the same care as a high-end production car.',
      cta:    'Our full story',
    },
    services: {
      label:   'Our expertise',
      title:   'Six trades, one team',
      viewAll: 'View all services',
      items: [
        { name: 'New construction',  desc: 'Bespoke villas, from the first sketch to handover.',                                          link: '/services/construction' },
        { name: 'Renovation',        desc: 'Full or partial transformation, without altering the existing character.',                    link: '/services/renovation'   },
        { name: 'Interior design',   desc: 'Custom joinery, careful finishes, integrated home automation.',                              link: '/services/interieur'    },
        { name: 'Outdoor spaces',    desc: 'Gardens, terraces and lighting designed as a natural extension of the living room.',          link: '/services/exterieur'    },
        { name: 'Swimming pools',    desc: 'Infinity, natural or automated: each design is drawn for its site.',                          link: '/services/piscine'      },
        { name: 'Stone masonry',     desc: 'Catalan stone worked by hand. Vaults, load-bearing walls, staircases.',                       link: '/services/maconnerie'   },
      ],
    },
    partnership: {
      label: 'A complete ecosystem',
      title: 'Build, manage, grow.',
      desc:  'We work in exclusive partnership with Solenca, who take over once the house is handed over: rental management, concierge service, maintenance. Construcciones Remalex builds, Solenca handles what comes next. One ecosystem for your investment on the Costa Brava.',
      tag1:  'Construction & Renovation',
      tag2:  'Property Management',
      cta:   'Discover Solenca',
    },
    testimonial: {
      quote:    'Sebastian and his team turned our Catalan mas into a real family villa. German rigour applied to Catalan building. We never imagined a result at this level.',
      author:   'Thomas & Anna H.',
      location: 'Platja d\'Aro · Clients since 2022',
    },
    cta: {
      title:    'Got a project in mind?',
      subtitle: 'The first conversation is free. We can talk it over a coffee in Platja d\'Aro, or by phone if you are further away.',
      btn1:     'Contact us',
      btn2:     '+34 602 645 005',
    },
    footer: {
      tagline:      'Your house in our care.',
      servicesTitle:'Expertise',
      navTitle:     'Navigation',
      contactTitle: 'Contact',
      address:      "Carrer dels Avets 5\nCastell d'Aro, Girona",
      hours:        'Mon – Sun: 9:00 AM – 5:00 PM',
      legal:        'Legal notice',
      privacy:      'Privacy policy',
      cookies:      'Cookies',
      rights:       'All rights reserved.',
      developedBy:  'Developed by',
      adminTooltip: 'Administration area',
      adminLabel:   'Admin',
      navLinks: [
        { label: 'Home',        to: '/'                 },
        { label: 'Expertise',   to: '/services'         },
        { label: 'Projects',    to: '/realisations'     },
        { label: 'For sale',    to: '/projets-en-vente' },
        { label: 'Our story',   to: '/a-propos'         },
        { label: 'Partners',    to: '/partenaires'      },
        { label: 'Contact',     to: '/contact'          },
      ],
    },
    about: {
      heroLabel:   'About us',
      heroTitle:   'Building what matters.',
      heroSub:     'Construcciones Remalex S.L., construction and renovation on the Costa Brava since 2021.',
      storyLabel:  'Our DNA',
      storyTitle:  'German rigour,\nat the service of Spanish living.',
      storyP1:     'Before he set foot on the Costa Brava, Sebastian Lemke built his career inside the major German automotive groups. He started on the floor and worked his way up every rung, becoming a recognised name in industry sales. His main quality: hearing what a client is really looking for, sometimes before they can put it into words.',
      storyP2:     'In 2021, he founded his construction company in Platja d\'Aro. The idea was simple: apply the German methods he knew, in Spain. He gathered a circle of craftsmen based in the region and held to one strict rule, the respect of agreed deadlines.',
      storyP3:     'In 2026, the company was restructured. CasaCare Remalex became Construcciones Remalex S.L., and the maintenance branch was transferred to Solenca, a long-standing partner. Sebastian could then focus on what had drawn him in from the start: construction and renovation.',
      valuesLabel: 'Our values',
      valuesTitle: 'What guides us',
      values: [
        { num: '01', title: 'Standards',  desc: 'We apply the methods of a German production line to buildings: tight tolerances, checks at every stage, nothing leaves the site half done.' },
        { num: '02', title: 'Proximity',  desc: 'Sebastian follows every site personally. One point of contact, reachable in French, German, English or Spanish.' },
        { num: '03', title: 'Trust',      desc: 'Detailed quotes, a shared schedule, supplier invoices on request. You know where every euro goes.' },
        { num: '04', title: 'Respect',    desc: 'Respect for the place, the existing structure, your taste and the Catalan landscape the house sits in.' },
      ],
      founderLabel: 'The founder',
      founderTitle: 'Dr. h.c. Sebastian Lemke',
      founderRole:  'Founder & Managing Director',
      founderBio1:  'Sebastian Lemke spent his entire commercial career inside the major German car manufacturers, becoming one of the recognised names in the sector. His strength: grasping quickly what the person in front of him is looking for, and giving back a concrete answer, without sales talk.',
      founderBio2:  'Multilingual (German, French, Spanish, English), he brought the automotive industry\'s method to the Costa Brava: tight planning, quality control at each stage, delivery on the agreed date. He works with a core team of local craftsmen he knows well, and with whom he has worked for several years.',
      timelineLabel:'Our history',
      timelineTitle:'Five years on site',
      timeline: [
        { year: '2021', title: 'Founded',                   desc: 'Sebastian Lemke founds CasaCare Remalex in Platja d\'Aro. The idea: apply German working methods to the Catalan market.' },
        { year: '2022', title: 'First successes',           desc: 'The first delivered projects get noticed. The demanding international clientele recommends the company by word of mouth.' },
        { year: '2023', title: 'Solenca partnership',       desc: 'The strategic partnership with Solenca is set up, taking on rental management and concierge service once the house is handed over.' },
        { year: '2024', title: 'Expansion',                 desc: 'The team grows with new craftsmen recruited in the region. The company runs new-builds and major renovations in parallel.' },
        { year: '2025', title: '100+ projects',             desc: 'The hundred-project mark is reached. Remalex settles in as a local reference for construction and renovation.' },
        { year: '2026', title: 'Construcciones Remalex',   desc: 'Restructuring: the maintenance branch is transferred to Solenca, and the company is renamed Construcciones Remalex S.L. Sebastian focuses on construction and renovation.' },
      ],
      certifLabel: 'Certifications & guarantees',
      certifs: [
        { title: 'Professional Liability Insurance', desc: 'Full coverage for all our projects'  },
        { title: 'Spanish Official Register',        desc: 'Registered and certified company'    },
        { title: 'Spanish NIF',                      desc: 'Full fiscal compliance'              },
      ],
      ctaTitle: 'Let\'s talk about your project',
      ctaBtn:   'Contact us',
    },
    contact: {
      heroLabel: 'Contact',
      heroTitle: 'Let\'s talk about your project.',
      heroSub:   'The first conversation is free. We reply in French, English, German and Spanish.',
      infoTitle: 'Find us',
      form: {
        name:         'First & Last name',
        email:        'Email',
        phone:        'Phone',
        projectType:  'Project type',
        budget:       'Estimated budget',
        message:      'Describe your project',
        privacy:      'I agree that my data may be used to respond to my enquiry.',
        submit:       'Send my enquiry',
        success:      'Your message has been sent!',
        successSub:   'We\'ll get back to you within 24 hours.',
        projectTypes: [
          { value: 'newBuild',   label: 'New construction' },
          { value: 'renovation', label: 'Renovation'       },
          { value: 'pool',       label: 'Swimming pool'    },
          { value: 'outdoor',    label: 'Outdoor spaces'   },
          { value: 'other',      label: 'Other'            },
        ],
        budgets: [
          { value: '50-100',  label: '€50,000 – €100,000'  },
          { value: '100-250', label: '€100,000 – €250,000' },
          { value: '250-500', label: '€250,000 – €500,000' },
          { value: '500+',    label: '€500,000+'           },
        ],
      },
    },
    contactPage: {
      addressLabel:    'Address',
      phoneLabel:      'Phone',
      hoursLabel:      'Hours',
      languagesLabel:  'Languages',
      address:         "Carrer dels Avets, 5\n17250 Castell d'Aro, Girona\nCosta Brava, España",
      required:        '* required',
      emailPlaceholder:'you@email.com',
      phonePlaceholder:'600 000 000',
      newRequest:      'New request',
      errorGeneric:    'Something went wrong.',
    },
    partnersPage: {
      heroLabel:    'Network',
      heroTitle:    'Our Partners.',
      heroSub:      'Construcciones Remalex works with a few selected partners on the Costa Brava to cover the full chain, from purchase and land to property management.',
      ctaLabel:     'Your project',
      visitWebsite: 'Visit website',
      categories: {
        solenca:    'Maintenance & Property Management',
        lucasFox:   'Premium Real Estate Agency',
      },
    },
    newsPage: {
      title:       'News',
      subtitle:    'Latest updates from Construcciones Remalex',
      readMore:    'Read more',
      backToList:  'Back to news',
      publishedOn: 'Published on',
      empty:       'No articles yet.',
    },
    servicesPage: {
      hero: {
        label:    'Our Expertise',
        title:    'Six trades under one roof.',
        subtitle: 'From new construction to major renovation, we coordinate every trade needed for your project on the Costa Brava, without subcontracting site management.',
      },
      learnMore: 'Learn more',
      partnership: {
        label:     'Exclusive partnership',
        title:     'Build and manage, under one roof.',
        desc:      'Solenca, a Costa Brava real estate agency, takes over once the house is handed over: rental management, concierge service, maintenance. Construcciones Remalex builds, Solenca handles the rest. One contact on the construction side, one on the management side.',
        ecosystem: 'A complete ecosystem',
        tagBadge:  'Construction + Management',
        cta:       'Discover Solenca',
      },
      cta: {
        label:    'Your project',
        title:    'Shall we talk about it?',
        subtitle: 'A first meeting, no commitment, so we can understand what you have in mind and see whether we can help.',
        btn:      'Contact us',
      },
      services: [
        { id: 'construction', num: '01', title: 'New Construction',     tag: 'Bespoke villas',          description: "Villas designed for their site: orientation, views, light, integration into the Costa Brava landscape. Contemporary architecture, Mediterranean vocabulary.", features: ['Bespoke architecture', 'Selected materials', 'Personal oversight by Sebastian'], image: '/images/new-construction.webp' },
        { id: 'renovation',   num: '02', title: 'Renovation',           tag: 'Full transformation',     description: "Renovate without altering. Flats, villas, town houses: we keep what gives the place its character and bring the rest up to standard (insulation, services, finishes).", features: ['Full assessment', 'Complete site management', 'Trade coordination'], image: '/images/renovation.webp' },
        { id: 'masia',        num: '03', title: 'Masia Renovation',     tag: 'Catalan heritage',        description: "This is our speciality. A Catalan masia is renovated by its own rules: exposed stone, vaults, old beams. We keep them, and inject modern comfort on top.", features: ['Heritage conservation', 'Traditional techniques', 'Modern comfort integrated'], image: '/images/renovation-masia.webp' },
        { id: 'piscine',      num: '04', title: 'Swimming Pools',       tag: 'Design & Technology',     description: "Pools drawn for their site: mirror effect, natural lagoon, heated basin. Each project takes the soil, the wind and the local climate into account.", features: ['Custom design', 'Latest-generation filtration', 'Landscape integration'], image: '/images/pool.webp' },
        { id: 'exterieur',    num: '05', title: 'Outdoor Landscaping',  tag: 'Gardens & Terraces',      description: "Terraces, gardens, paths, outdoor dining areas: we extend the house out towards the Catalan landscape, rather than putting the two in opposition.", features: ['Landscape design', 'Custom paving and terracing', 'Architectural lighting'], image: '/images/garden-amenagement.webp' },
        { id: 'maintenance',  num: '06', title: 'Maintenance',          tag: 'Follow-up & Peace of Mind', description: "With Solenca, our partner specialised in property management on the Costa Brava, we take care of routine upkeep: plumbing, electrics, gardening, pool, concierge service. You keep a single point of contact.", features: ['Exclusive Solenca partnership', 'Bespoke annual contracts', 'Rental & concierge management'], image: '/solenca-van.webp' },
      ],
    },
    projectsPage: {
      hero: {
        label:       'Projects',
        title1:      'Our',
        titleItalic: 'projects.',
        subtitle:    'A selection of projects delivered over the past few years: new builds, masia renovations, pools, outdoor work.',
      },
      categories: [
        { id: 'all',        label: 'All'          },
        { id: 'newBuild',   label: 'Construction'  },
        { id: 'renovation', label: 'Renovation'    },
        { id: 'pool',       label: 'Pools'         },
        { id: 'outdoor',    label: 'Outdoor'       },
      ],
      typeLabels: {
        newBuild:   'Construction',
        renovation: 'Renovation',
        pool:       'Pool',
        outdoor:    'Outdoor',
        masonry:    'Masonry',
      },
      noResults: 'No projects in this category.',
    },
    legalPage: {
      label: 'Legal',
      mentionsTitle: 'Legal notice',
      privacyTitle:  'Privacy policy',
    },
    servicePages: {
      breadcrumbBase: 'Services',
      ourAssets: 'Our Strengths',
      ourServices: 'Our Offers',
      ourWork: 'Our Work',
      yourProject: 'Your project',
      ctaTitle: 'Let\'s discuss your project',
      ctaBtn: 'Request a quote',
      construction: {
        breadcrumb: 'New Construction',
        heroLabel:  'New Construction',
        heroTitle1: 'Bespoke',
        heroTitleItalic: 'homes',
        heroSubtitle: 'A villa starts with a plot of land. We design the house around it: orientation, views, materials. Contemporary Mediterranean architecture, careful finishes.',
        heroCta:    'Start my project',
        featuresLabel: 'Our Strengths',
        featuresTitle: 'Our method, step by step',
        processLabel: 'Process',
        processTitle: 'From idea to handover',
        ctaSubtitle: 'First meeting is free. We look at your plot and discuss first directions together.',
        features: [
          { title: 'Bespoke architecture',  description: 'Plans drawn for your plot and the way you live. No model duplicated from one project to the next.' },
          { title: 'Premium materials',     description: 'Natural stone, certified wood, stainless steel: we select the materials with you, supplier by supplier.' },
          { title: 'Integrated team',       description: 'Architects, engineers and craftsmen coordinated in-house, with no buck-passing between providers.' },
          { title: 'Ten-year warranty',     description: 'Ten-year guarantee on handover, in line with Spanish law. The work is covered for ten years.' },
        ],
        process: [
          { num: '01', title: 'Site survey',              desc: 'Topographic analysis, soil study, planning constraints.' },
          { num: '02', title: 'Architectural design',     desc: '3D plans, material selection, energy optimisation.' },
          { num: '03', title: 'Permits & procedures',     desc: 'Full management of administrative authorisations.' },
          { num: '04', title: 'Construction',             desc: 'Site supervision with regular check-ins and weekly photos.' },
          { num: '05', title: 'Handover',                 desc: 'Final inspection and key handover of your villa.' },
        ],
      },
      renovation: {
        breadcrumb: 'Renovation',
        heroLabel:  'Renovation',
        heroTitle1: 'Transform,',
        heroTitleItalic: 'without altering',
        heroSubtitle: 'A successful renovation keeps what gives the place its character and brings the rest up to standard: insulation, services, light, layout. From Catalan masias to contemporary villas.',
        heroCta:    'Assess my project',
        featuresLabel: 'Our Strengths',
        featuresTitle: 'Why choose us',
        typesLabel:  'Our Offers',
        typesTitle:  'Tailored solutions',
        ctaSubtitle: 'Free assessment, detailed estimate. We come to see the property and discuss it on site.',
        features: [
          { title: 'Full assessment',           description: 'Evaluation of the structure, the services and the transformation potential, before any pricing.' },
          { title: 'Energy optimisation',       description: 'Insulation, ventilation, solar panels: lower bills, better comfort.' },
          { title: 'Heritage enhancement',      description: 'Restoration of original features without freezing them: Catalan vaults, stone walls, terracotta tiles.' },
          { title: 'Smart modernisation',       description: 'Discreet integration of current equipment: home automation, air conditioning, security.' },
        ],
        types: [
          { title: 'Full renovation',   desc: 'Complete rework, from structure to finishes.' },
          { title: 'Partial renovation',desc: 'Targeted work: kitchen, bathrooms, living spaces.' },
          { title: 'Extension',         desc: 'Extension cleanly tied into the existing building.' },
        ],
      },
      exterieur: {
        breadcrumb: 'Outdoor Landscaping',
        heroLabel:  'Outdoor Landscaping',
        heroTitle1: 'Gardens &',
        heroTitleItalic: 'terraces',
        heroSubtitle: 'A well-designed outdoor space extends the house towards the Catalan landscape. We draw gardens and terraces suited to the Mediterranean climate, to summer water scarcity and to your way of life.',
        heroCta:    'Design my garden',
        featuresLabel: 'Our Strengths',
        featuresTitle: 'A bespoke garden',
        galleryLabel: 'Our Work',
        galleryTitle: 'Selected projects',
        ctaSubtitle: 'Free landscape consultation. We come to see your outdoor space and discuss it on site.',
        services: [
          { title: 'Landscape design',    description: 'Mediterranean gardens, planting chosen to withstand the dry Costa Brava summers.', items: ['3D landscape plans', 'Plant selection', 'Irrigation systems'] },
          { title: 'Architectural lighting',description: 'Subtle lighting of the garden and façade, with no light pollution.', items: ['Low-energy LED', 'Lighting scenes', 'Automation'] },
          { title: 'Terraces & pergolas', description: 'Outdoor living spaces designed for the Mediterranean climate: shade in summer, sun in winter.', items: ['Certified exotic wood', 'Natural stone', 'Bioclimatic pergolas'] },
          { title: 'Water management',    description: 'Sustainable solutions for irrigation and water harvesting, essential on the Catalan coast.', items: ['Rainwater harvesting', 'Smart irrigation', 'Fountains & ponds'] },
        ],
      },
      interieur: {
        breadcrumb: 'Interior Design',
        heroLabel:  'Interior Design',
        heroTitle1: 'Interiors',
        heroTitleItalic: 'down to the line',
        heroSubtitle: 'An interior that works before it is beautiful. Custom joinery, surfaces chosen supplier by supplier, discreet home automation: we work the details, because those are what you live with every day.',
        heroCta:    'Design my interior',
        featuresLabel: 'Our Strengths',
        featuresTitle: 'Attention to detail',
        roomsLabel:  'Our Offers',
        roomsTitle:  'Bespoke rooms',
        galleryLabel: 'Our Work',
        galleryTitle: 'A few inspirations',
        ctaSubtitle: 'Free design consultation. Bring your references, we discuss them together.',
        services: [
          { title: 'Custom joinery',       description: 'Doors, windows, wardrobes and dressing rooms designed and made for your interior, room by room.', items: ['Solid wood & MDF', 'Contemporary or classic design', 'Lacquered or natural finishes'] },
          { title: 'Premium surfaces',     description: 'Floors, walls and ceilings in solid materials, chosen to last.', items: ['Solid & engineered parquet', 'Natural stone & tiles', 'Decorative plasters'] },
          { title: 'Integrated automation',description: 'Systems controlled for comfort and security, integrated without taking over the space.', items: ['Automated lighting', 'Zoned climate control', 'Connected security'] },
          { title: 'High-end finishes',    description: 'Details make the difference over time: clean joints, invisible junctions, paint without defect.', items: ['Eco-friendly paints', 'Plaster mouldings', 'Architectural lighting'] },
        ],
        rooms: [
          { name: 'Kitchens',   desc: 'Italian design, professional appliances' },
          { name: 'Bathrooms',  desc: 'Private spa, designer taps' },
          { name: 'Dressing rooms', desc: 'Bespoke organisation, integrated lighting' },
          { name: 'Staircases', desc: 'Wood, metal or glass, depending on the project' },
        ],
      },
      maconnerie: {
        breadcrumb: 'Masonry',
        heroLabel:  'Masonry',
        heroTitle1: 'The art of',
        heroTitleItalic: 'stone',
        heroSubtitle: 'Our masons work the stone the way it has always been done in the region, with today\'s tools. Natural stone, Catalan vaults, lime renders: a craft passed on through the work, not the brochures.',
        heroCta:    'Discuss my project',
        techniquesLabel: 'Our Offers',
        techniquesTitle: 'Traditional techniques',
        servicesLabel:   'Our Strengths',
        servicesTitle:   'From foundations to finishes',
        commitmentTitle: 'Our commitment',
        commitmentDesc:  'Our masonry work is carried out by our in-house teams, trained in traditional Catalan techniques and current standards.',
        ctaSubtitle: 'Free consultation, detailed quote. Our teams come to look at your project on site.',
        techniques: [
          { title: 'Natural stone',        description: 'Dry stone walls, cladding, opus incertum. We work with local Girona stone, supplied by quarries we know.' },
          { title: 'Catalan vaults',       description: 'Construction technique using bricks laid flat, a signature of Mediterranean architecture. Few teams still master it. Ours does.' },
          { title: 'Decorative concrete',  description: 'Polished, printed and exposed aggregate concrete for floors and low walls.' },
        ],
        services: ['Foundations and structure', 'Load-bearing walls and partitions', 'Stone staircases', 'Fireplaces and barbecues', 'Garden walls and fencing', 'Façade restoration', 'Traditional renders', 'Exposed stone pointing'],
        commitments: ['Locally sourced materials where possible', 'Respect for traditional Catalan techniques', 'Ten-year guarantee on all our work'],
      },
      piscine: {
        breadcrumb: 'Swimming Pools',
        heroLabel:  'Swimming Pools',
        heroTitle1: 'The art of',
        heroTitleItalic: 'water',
        heroSubtitle: 'Pools drawn to sit within the site and the house, rather than placed on top. From the first sketch to the technical equipment, we run the whole job.',
        heroCta:    'Design my pool',
        featuresLabel: 'Our Strengths',
        featuresTitle: 'Technologies & Design',
        typesLabel:  'Our Offers',
        typesTitle:  'Choose your style',
        galleryLabel: 'Our Work',
        galleryTitle: 'Selected projects',
        ctaSubtitle: 'Free feasibility study. We look at your land and what you have in mind.',
        features: [
          { title: 'Infinity pool',        description: 'Mirror effect set into the Mediterranean landscape, calibrated for your view.' },
          { title: 'Solar heating',        description: 'To extend the swimming season without weighing down the energy bill.' },
          { title: 'Natural treatment',    description: 'Chlorine alternatives: salt, UV, or biological pools for softer water.' },
          { title: 'Full automation',      description: 'Filtration, heating, lighting controlled remotely from your phone.' },
        ],
        types: [
          { title: 'Traditional pool',  desc: 'Reinforced concrete construction, custom dimensions, tile or liner finish.', size: '8×4 m' },
          { title: 'Infinity pool',     desc: 'Mirror effect and visual continuity with the landscape.', size: '10×5 m' },
          { title: 'Biological pool',   desc: 'Natural basin with a plant regeneration zone.', size: '12×6 m' },
        ],
      },
    },
  },

  // ── DEUTSCH ────────────────────────────────────────────────────────────────
  de: {
    nav: {
      services: 'Leistungen',
      projects: 'Referenzen',
      forSale:  'Zu verkaufen',
      about:    'Über uns',
      news:     'Aktuelles',
      contact:  'Kontakt',
      cta:      'Kostenlos anfragen',
    },
    hero: {
      label:    'Platja d\'Aro · Costa Brava',
      title:    ['Das Wesentliche', 'bauen.'],
      subtitle: 'Ein deutsches Bauunternehmen an der Costa Brava. Ein Ansprechpartner, ein eingehaltener Zeitplan, eine Baustelle, die von Anfang bis Ende begleitet wird.',
      cta1:     'Unsere Projekte entdecken',
      cta2:     'Kostenlos anfragen',
      scroll:   'Scrollen',
    },
    stats: [
      { value: '100+', label: 'Abgeschlossene Projekte' },
      { value: '5',    label: 'Jahre Erfahrung'         },
      { value: '4',    label: 'Sprachen'                },
      { value: '100%', label: 'Empfehlungen'            },
    ],
    story: {
      label:  'Unsere Geschichte',
      quote:  'Was mich seit jeher leitet, ist zu verstehen, was der Kunde wirklich will, und es dann termingerecht zu liefern.',
      author: '— Sebastian Lemke, Gründer',
      title:  'Automobiler Anspruch,\nangewandt auf Ihr Zuhause.',
      p1:     'Vor der Costa Brava verbrachte Sebastian Lemke Jahre in den großen deutschen Automobilhäusern. Eine anspruchsvolle Schule, in der man lernt, termingerecht und ohne Annäherung zu liefern. Dann hat ihn die Region behalten.',
      p2:     'Er ließ sich in Platja d\'Aro nieder und gründete Construcciones Remalex S.L. um eine einfache Idee herum: Ein Haus soll mit derselben Sorgfalt gebaut werden wie ein Serienfahrzeug der Oberklasse.',
      cta:    'Unsere vollständige Geschichte',
    },
    services: {
      label:   'Unsere Leistungen',
      title:   'Sechs Gewerke, ein Team',
      viewAll: 'Alle Leistungen ansehen',
      items: [
        { name: 'Neubau',               desc: 'Maßgeschneiderte Villen, von der ersten Skizze bis zur Schlüsselübergabe.',                link: '/services/construction' },
        { name: 'Renovierung',          desc: 'Vollständige oder teilweise Sanierung, ohne den Charakter der vorhandenen Bausubstanz zu verändern.', link: '/services/renovation'   },
        { name: 'Innenausbau',          desc: 'Maßtischlerei, sorgfältige Oberflächen, integrierte Haustechnik.',                         link: '/services/interieur'    },
        { name: 'Außenbereiche',        desc: 'Gärten, Terrassen und Beleuchtung, gedacht als Verlängerung des Wohnraums.',               link: '/services/exterieur'    },
        { name: 'Schwimmbäder',         desc: 'Überlauf, Naturpool oder automatisiert: jedes Projekt wird für das Gelände gezeichnet.',   link: '/services/piscine'      },
        { name: 'Steinmauerwerk',       desc: 'Katalanischer Stein, von Hand bearbeitet. Gewölbe, tragende Mauern, Treppen.',             link: '/services/maconnerie'   },
      ],
    },
    partnership: {
      label: 'Komplettes Ökosystem',
      title: 'Bauen, verwalten, aufwerten.',
      desc:  'Wir arbeiten in exklusiver Partnerschaft mit Solenca, das nach der Übergabe übernimmt: Mietverwaltung, Concierge-Service, Instandhaltung. Construcciones Remalex baut, Solenca kümmert sich um das Danach. Ein Ökosystem für eine Investition an der Costa Brava.',
      tag1:  'Bau & Renovierung',
      tag2:  'Property Management',
      cta:   'Solenca entdecken',
    },
    testimonial: {
      quote:    'Sebastian und sein Team haben aus unserer katalanischen Masia eine echte Familienvilla gemacht. Deutsche Sorgfalt auf katalanischer Bausubstanz: ein Ergebnis in dieser Qualität hatten wir nicht erwartet.',
      author:   'Thomas & Anna H.',
      location: 'Platja d\'Aro · Kunden seit 2022',
    },
    cta: {
      title:    'Haben Sie ein Projekt im Kopf?',
      subtitle: 'Das erste Gespräch ist kostenlos. Wir können bei einem Kaffee in Platja d\'Aro darüber sprechen, oder am Telefon, wenn Sie weiter weg sind.',
      btn1:     'Kontakt aufnehmen',
      btn2:     '+34 602 645 005',
    },
    footer: {
      tagline:      'Your house in our care.',
      servicesTitle:'Leistungen',
      navTitle:     'Navigation',
      contactTitle: 'Kontakt',
      address:      "Carrer dels Avets 5\nCastell d'Aro, Girona",
      hours:        'Mo – So: 9:00 – 17:00 Uhr',
      legal:        'Impressum',
      cookies:      'Cookies',
      privacy:      'Datenschutz',
      rights:       'Alle Rechte vorbehalten.',
      developedBy:  'Entwickelt von',
      adminTooltip: 'Verwaltungsbereich',
      adminLabel:   'Admin',
      navLinks: [
        { label: 'Startseite',     to: '/'                 },
        { label: 'Leistungen',     to: '/services'         },
        { label: 'Referenzen',     to: '/realisations'     },
        { label: 'Zu verkaufen',   to: '/projets-en-vente' },
        { label: 'Über uns',       to: '/a-propos'         },
        { label: 'Partner',        to: '/partenaires'      },
        { label: 'Kontakt',        to: '/contact'          },
      ],
    },
    about: {
      heroLabel:   'Über uns',
      heroTitle:   'Das Wesentliche bauen.',
      heroSub:     'Construcciones Remalex S.L., Bau und Renovierung an der Costa Brava seit 2021.',
      storyLabel:  'Unsere DNA',
      storyTitle:  'Deutsche Sorgfalt,\nim Dienst des spanischen Wohnens.',
      storyP1:     'Bevor er an der Costa Brava ankam, hat Sebastian Lemke seine Laufbahn in den großen deutschen Automobilkonzernen gemacht. Er ist vom Verkaufsfeld eingestiegen und hat alle Stufen durchlaufen, bis er zu einer anerkannten Vertriebsfigur der Branche wurde. Seine wichtigste Eigenschaft: zu hören, was ein Kunde wirklich sucht, manchmal bevor dieser es selbst formulieren kann.',
      storyP2:     '2021 gründete er sein Bauunternehmen in Platja d\'Aro. Die Idee war einfach: die Arbeitsweise, die er kannte, in Spanien anzuwenden. Er umgab sich mit Handwerkern aus der Region und hielt sich an eine strikte Regel, die Einhaltung der zugesagten Termine.',
      storyP3:     '2026 wurde das Unternehmen neu strukturiert. Aus CasaCare Remalex wurde Construcciones Remalex S.L., und der Bereich Instandhaltung ging an Solenca, einen langjährigen Partner. Sebastian konnte sich dann auf das konzentrieren, was ihn von Anfang an interessiert hat: Bau und Renovierung.',
      valuesLabel: 'Unsere Werte',
      valuesTitle: 'Was uns leitet',
      values: [
        { num: '01', title: 'Anspruch',   desc: 'Wir wenden auf den Bau die Methoden einer deutschen Fertigungslinie an: enge Toleranzen, Kontrolle in jeder Phase, nichts verlässt die Baustelle halbfertig.' },
        { num: '02', title: 'Nähe',       desc: 'Sebastian begleitet jede Baustelle selbst. Ein einziger Ansprechpartner, erreichbar auf Deutsch, Französisch, Englisch oder Spanisch.' },
        { num: '03', title: 'Vertrauen',  desc: 'Detaillierte Angebote, geteilter Zeitplan, Lieferantenrechnungen auf Anfrage. Sie wissen, wohin jeder Euro fließt.' },
        { num: '04', title: 'Respekt',    desc: 'Respekt vor dem Ort, der bestehenden Bausubstanz, Ihrem Geschmack und der katalanischen Landschaft, in der das Haus steht.' },
      ],
      founderLabel: 'Der Gründer',
      founderTitle: 'Dr. h.c. Sebastian Lemke',
      founderRole:  'Gründer & Geschäftsführer',
      founderBio1:  'Sebastian Lemke hat seine gesamte vertriebliche Laufbahn bei den großen deutschen Automobilherstellern verbracht und ist zu einer der anerkannten Figuren der Branche geworden. Seine Stärke: schnell zu erfassen, was sein Gegenüber sucht, und eine konkrete Antwort zu geben, ohne Verkaufsfloskeln.',
      founderBio2:  'Mehrsprachig (Deutsch, Französisch, Spanisch, Englisch), hat er die Methode der Automobilindustrie an die Costa Brava gebracht: enger Zeitplan, Qualitätskontrolle in jeder Phase, Lieferung zum vereinbarten Termin. Er stützt sich auf einen Kern lokaler Handwerker, die er kennt und mit denen er seit mehreren Jahren zusammenarbeitet.',
      timelineLabel:'Unsere Geschichte',
      timelineTitle:'Fünf Jahre Baustellen',
      timeline: [
        { year: '2021', title: 'Gründung',                    desc: 'Sebastian Lemke gründet CasaCare Remalex in Platja d\'Aro. Die Idee: die deutschen Arbeitsmethoden auf den katalanischen Markt anwenden.' },
        { year: '2022', title: 'Erste Erfolge',               desc: 'Die ersten übergebenen Projekte werden bemerkt. Die anspruchsvolle internationale Kundschaft empfiehlt das Unternehmen über Mundpropaganda weiter.' },
        { year: '2023', title: 'Solenca-Partnerschaft',       desc: 'Aufbau der strategischen Partnerschaft mit Solenca, das nach der Übergabe Mietverwaltung und Concierge-Service übernimmt.' },
        { year: '2024', title: 'Expansion',                   desc: 'Das Team wächst durch neue Handwerker aus der Region. Das Unternehmen führt parallel Neubauten und größere Renovierungen aus.' },
        { year: '2025', title: '100+ Projekte',               desc: 'Die Marke von hundert übergebenen Projekten wird überschritten. Remalex etabliert sich als lokale Referenz für Bau und Renovierung.' },
        { year: '2026', title: 'Construcciones Remalex',      desc: 'Umstrukturierung: Der Bereich Instandhaltung wird an Solenca übertragen, und das Unternehmen wird in Construcciones Remalex S.L. umbenannt. Sebastian konzentriert sich auf Bau und Renovierung.' },
      ],
      certifLabel: 'Zertifizierungen & Garantien',
      certifs: [
        { title: 'Berufshaftpflichtversicherung', desc: 'Vollständige Absicherung unserer Baustellen'   },
        { title: 'Spanisches Amtsregister',       desc: 'Eingetragenes und zertifiziertes Unternehmen' },
        { title: 'Spanische NIF',                 desc: 'Vollständige steuerliche Compliance'          },
      ],
      ctaTitle: 'Sprechen wir über Ihr Projekt',
      ctaBtn:   'Kontakt aufnehmen',
    },
    contact: {
      heroLabel: 'Kontakt',
      heroTitle: 'Sprechen wir über Ihr Projekt.',
      heroSub:   'Das erste Gespräch ist kostenlos. Wir antworten auf Deutsch, Französisch, Englisch und Spanisch.',
      infoTitle: 'So finden Sie uns',
      form: {
        name:         'Vor- & Nachname',
        email:        'E-Mail',
        phone:        'Telefon',
        projectType:  'Projekttyp',
        budget:       'Geschätztes Budget',
        message:      'Beschreiben Sie Ihr Projekt',
        privacy:      'Ich bin damit einverstanden, dass meine Daten zur Beantwortung meiner Anfrage verwendet werden.',
        submit:       'Anfrage senden',
        success:      'Ihre Nachricht wurde erfolgreich gesendet!',
        successSub:   'Wir melden uns innerhalb von 24 Stunden.',
        projectTypes: [
          { value: 'newBuild',   label: 'Neubau'          },
          { value: 'renovation', label: 'Renovierung'     },
          { value: 'pool',       label: 'Schwimmbad'      },
          { value: 'outdoor',    label: 'Außenbereiche'   },
          { value: 'other',      label: 'Sonstiges'       },
        ],
        budgets: [
          { value: '50-100',  label: '50.000 € – 100.000 €'  },
          { value: '100-250', label: '100.000 € – 250.000 €' },
          { value: '250-500', label: '250.000 € – 500.000 €' },
          { value: '500+',    label: '500.000 € +'           },
        ],
      },
    },
    contactPage: {
      addressLabel:    'Adresse',
      phoneLabel:      'Telefon',
      hoursLabel:      'Öffnungszeiten',
      languagesLabel:  'Sprachen',
      address:         "Carrer dels Avets, 5\n17250 Castell d'Aro, Girona\nCosta Brava, España",
      required:        '* erforderlich',
      emailPlaceholder:'ihre@email.com',
      phonePlaceholder:'600 000 000',
      newRequest:      'Neue Anfrage',
      errorGeneric:    'Ein Fehler ist aufgetreten.',
    },
    partnersPage: {
      heroLabel:    'Netzwerk',
      heroTitle:    'Unsere Partner.',
      heroSub:      'Construcciones Remalex arbeitet mit einigen ausgewählten Akteuren an der Costa Brava zusammen, um die gesamte Kette abzudecken, vom Kauf und Grundstück bis zur Verwaltung der Immobilie.',
      ctaLabel:     'Ihr Projekt',
      visitWebsite: 'Website besuchen',
      categories: {
        solenca:    'Wartung & Immobilienverwaltung',
        lucasFox:   'Premium-Immobilienagentur',
      },
    },
    newsPage: {
      title:       'Neuigkeiten',
      subtitle:    'Aktuelles von Construcciones Remalex',
      readMore:    'Mehr lesen',
      backToList:  'Zurück zur Übersicht',
      publishedOn: 'Veröffentlicht am',
      empty:       'Noch keine Artikel.',
    },
    servicesPage: {
      hero: {
        label:    'Unsere Leistungen',
        title:    'Sechs Gewerke unter einem Dach.',
        subtitle: 'Von Neubau bis zur großen Sanierung koordinieren wir alle für Ihr Bauvorhaben an der Costa Brava nötigen Gewerke, ohne die Bauleitung weiterzugeben.',
      },
      learnMore: 'Mehr erfahren',
      partnership: {
        label:     'Exklusive Partnerschaft',
        title:     'Bauen und verwalten aus einer Hand.',
        desc:      'Solenca, Immobilienagentur an der Costa Brava, übernimmt nach der Übergabe: Mietverwaltung, Concierge-Service, Instandhaltung. Construcciones Remalex baut, Solenca kümmert sich um den Rest. Ein Ansprechpartner auf der Bauseite, einer auf der Verwaltungsseite.',
        ecosystem: 'Komplettes Ökosystem',
        tagBadge:  'Bau + Verwaltung',
        cta:       'Solenca entdecken',
      },
      cta: {
        label:    'Ihr Projekt',
        title:    'Sprechen wir darüber?',
        subtitle: 'Ein erstes Treffen, unverbindlich, damit wir verstehen, was Sie im Kopf haben, und sehen, ob wir Ihnen helfen können.',
        btn:      'Kontakt aufnehmen',
      },
      services: [
        { id: 'construction', num: '01', title: 'Neubau',               tag: 'Maßgeschneiderte Villen', description: "Villen, die für ihr Grundstück gedacht sind: Ausrichtung, Aussicht, Licht, Einbindung in die Landschaft der Costa Brava. Zeitgenössische Architektur, mediterrane Sprache.", features: ['Maßgeschneiderte Architektur', 'Ausgewählte Materialien', 'Persönliche Betreuung durch Sebastian'], image: '/images/new-construction.webp' },
        { id: 'renovation',   num: '02', title: 'Renovierung',          tag: 'Komplettsanierung',       description: "Sanieren, ohne zu verfälschen. Wohnungen, Villen, Stadthäuser: Wir bewahren, was den Ort ausmacht, und bringen den Rest auf den aktuellen Stand (Dämmung, Leitungen, Oberflächen).", features: ['Vollständige Analyse', 'Komplettes Baustellenmanagement', 'Koordination der Handwerker'], image: '/images/renovation.webp' },
        { id: 'masia',        num: '03', title: 'Masia-Renovierung',    tag: 'Katalanisches Erbe',      description: "Das ist unsere Spezialität. Die katalanische Masia wird nach ihren eigenen Regeln saniert: Sichtstein, Gewölbe, alte Balken. Wir erhalten sie und ergänzen darüber den heutigen Komfort.", features: ['Erhalt des Kulturgutes', 'Traditionelle Techniken', 'Moderner Komfort integriert'], image: '/images/renovation-masia.webp' },
        { id: 'piscine',      num: '04', title: 'Schwimmbäder',         tag: 'Design & Technik',        description: "Pools, die für ihr Grundstück gezeichnet werden: Spiegeleffekt, Naturlagune, beheiztes Becken. Jedes Projekt berücksichtigt Boden, Wind und lokales Klima.", features: ['Individuelles Design', 'Modernste Filtertechnik', 'Landschaftliche Integration'], image: '/images/pool.webp' },
        { id: 'exterieur',    num: '05', title: 'Außengestaltung',      tag: 'Gärten & Terrassen',      description: "Terrassen, Gärten, Wege, Essbereiche im Freien: Wir setzen das Haus in die katalanische Landschaft hinein fort, statt beide gegeneinander zu stellen.", features: ['Gartenplanung', 'Maßgeschneiderte Pflasterung und Terrassen', 'Architektonische Beleuchtung'], image: '/images/garden-amenagement.webp' },
        { id: 'maintenance',  num: '06', title: 'Wartung & Service',    tag: 'Betreuung & Ruhe',        description: "Mit Solenca, unserem auf Immobilienverwaltung an der Costa Brava spezialisierten Partner, übernehmen wir die laufende Instandhaltung: Sanitär, Elektrik, Garten, Pool, Concierge. Sie behalten einen einzigen Ansprechpartner.", features: ['Exklusive Partnerschaft mit Solenca', 'Maßgeschneiderte Jahresverträge', 'Mietverwaltung & Concierge'], image: '/solenca-van.webp' },
      ],
    },
    projectsPage: {
      hero: {
        label:       'Referenzen',
        title1:      'Unsere',
        titleItalic: 'Projekte.',
        subtitle:    'Eine Auswahl der in den letzten Jahren übergebenen Baustellen: Neubauten, Masia-Sanierungen, Pools, Außengestaltung.',
      },
      categories: [
        { id: 'all',        label: 'Alle'         },
        { id: 'newBuild',   label: 'Neubau'        },
        { id: 'renovation', label: 'Renovierung'   },
        { id: 'pool',       label: 'Schwimmbäder'  },
        { id: 'outdoor',    label: 'Außenbereiche' },
      ],
      typeLabels: {
        newBuild:   'Neubau',
        renovation: 'Renovierung',
        pool:       'Schwimmbad',
        outdoor:    'Außen',
        masonry:    'Mauerwerk',
      },
      noResults: 'Keine Projekte in dieser Kategorie.',
    },
    legalPage: {
      label: 'Rechtliches',
      mentionsTitle: 'Impressum',
      privacyTitle:  'Datenschutzerklärung',
    },
    servicePages: {
      breadcrumbBase: 'Leistungen',
      ourAssets: 'Unsere Stärken',
      ourServices: 'Unsere Angebote',
      ourWork: 'Unsere Referenzen',
      yourProject: 'Ihr Projekt',
      ctaTitle: 'Sprechen wir über Ihr Projekt',
      ctaBtn: 'Angebot anfordern',
      construction: {
        breadcrumb: 'Neubau',
        heroLabel:  'Neubau',
        heroTitle1: 'Häuser',
        heroTitleItalic: 'nach Maß',
        heroSubtitle: 'Eine Villa beginnt mit einem Grundstück. Wir entwerfen das Haus darum herum: Ausrichtung, Aussicht, Materialien. Zeitgenössische mediterrane Architektur, sorgfältige Oberflächen.',
        heroCta:    'Mein Projekt starten',
        featuresLabel: 'Unsere Stärken',
        featuresTitle: 'Unsere Methode, Schritt für Schritt',
        processLabel: 'Ablauf',
        processTitle: 'Von der Idee zur Übergabe',
        ctaSubtitle: 'Erstes Treffen kostenlos. Wir schauen uns Ihr Grundstück an und besprechen erste Richtungen gemeinsam.',
        features: [
          { title: 'Maßgeschneiderte Architektur', description: 'Pläne, die für Ihr Grundstück und Ihre Lebensweise gezeichnet werden. Kein Modell, das von einer Baustelle zur nächsten kopiert wird.' },
          { title: 'Premium-Materialien',          description: 'Naturstein, zertifiziertes Holz, Edelstahl: Wir wählen die Materialien gemeinsam mit Ihnen aus, Lieferant für Lieferant.' },
          { title: 'Integriertes Team',            description: 'Architekten, Ingenieure und Handwerker im Haus koordiniert, ohne dass sich Dienstleister gegenseitig die Verantwortung zuschieben.' },
          { title: 'Zehnjährige Garantie',         description: 'Zehnjährige Gewährleistung bei Übergabe nach spanischem Recht. Die Baustelle ist zehn Jahre lang abgedeckt.' },
        ],
        process: [
          { num: '01', title: 'Geländeanalyse',            desc: 'Topografische Analyse, Bodengutachten, baurechtliche Einschränkungen.' },
          { num: '02', title: 'Architektonisches Design',  desc: '3D-Pläne, Materialauswahl, Energieoptimierung.' },
          { num: '03', title: 'Genehmigungen',             desc: 'Vollständige Verwaltung der behördlichen Genehmigungen.' },
          { num: '04', title: 'Bau',                       desc: 'Baustellenbegleitung mit regelmäßigen Etappenterminen und wöchentlichen Fotos.' },
          { num: '05', title: 'Übergabe',                  desc: 'Endabnahme und Schlüsselübergabe Ihrer Villa.' },
        ],
      },
      renovation: {
        breadcrumb: 'Renovierung',
        heroLabel:  'Renovierung',
        heroTitle1: 'Verändern,',
        heroTitleItalic: 'ohne zu verfälschen',
        heroSubtitle: 'Eine gelungene Sanierung bewahrt, was den Charakter des Ortes ausmacht, und bringt den Rest auf den aktuellen Stand: Dämmung, Leitungen, Licht, Grundriss. Von katalanischen Masias bis zu zeitgenössischen Villen.',
        heroCta:    'Mein Projekt bewerten',
        featuresLabel: 'Unsere Stärken',
        featuresTitle: 'Warum uns wählen',
        typesLabel:  'Unsere Angebote',
        typesTitle:  'Angepasste Lösungen',
        ctaSubtitle: 'Kostenlose Diagnose, detaillierte Schätzung. Wir kommen zur Immobilie und besprechen sie vor Ort.',
        features: [
          { title: 'Vollständige Analyse',      description: 'Bewertung von Struktur, Anlagen und Umbaupotenzial, bevor irgendetwas beziffert wird.' },
          { title: 'Energieoptimierung',        description: 'Dämmung, Lüftung, Solaranlagen: Niedrigere Rechnungen, mehr Komfort.' },
          { title: 'Denkmalpflege',             description: 'Restaurierung der Originalelemente, ohne sie zu erstarren: katalanische Gewölbe, Steinmauern, Terrakottafliesen.' },
          { title: 'Intelligente Modernisierung',description: 'Diskrete Integration aktueller Technik: Haustechnik, Klimatisierung, Sicherheit.' },
        ],
        types: [
          { title: 'Vollrenovierung',   desc: 'Komplette Erneuerung, von der Struktur bis zu den Oberflächen.' },
          { title: 'Teilrenovierung',   desc: 'Gezielte Arbeiten: Küche, Badezimmer, Wohnbereiche.' },
          { title: 'Erweiterung',       desc: 'Anbau, sauber an die bestehende Bausubstanz angeschlossen.' },
        ],
      },
      exterieur: {
        breadcrumb: 'Außengestaltung',
        heroLabel:  'Außengestaltung',
        heroTitle1: 'Gärten &',
        heroTitleItalic: 'Terrassen',
        heroSubtitle: 'Ein gut durchdachter Außenbereich setzt das Haus in die katalanische Landschaft hinein fort. Wir zeichnen Gärten und Terrassen, die zum mediterranen Klima passen, zur sommerlichen Wasserknappheit und zu Ihrem Lebensrhythmus.',
        heroCta:    'Meinen Garten gestalten',
        featuresLabel: 'Unsere Stärken',
        featuresTitle: 'Ein Garten nach Maß',
        galleryLabel: 'Unsere Referenzen',
        galleryTitle: 'Ausgewählte Projekte',
        ctaSubtitle: 'Kostenlose Gartenberatung. Wir kommen vor Ort und besprechen Ihren Außenbereich.',
        services: [
          { title: 'Gartenplanung',        description: 'Mediterrane Gärten, Bepflanzung, die den trockenen Sommern der Costa Brava standhält.', items: ['3D-Gartenpläne', 'Pflanzenauswahl', 'Bewässerungssysteme'] },
          { title: 'Architektonische Beleuchtung', description: 'Dezente Beleuchtung von Garten und Fassade, ohne Lichtverschmutzung.', items: ['Energiesparende LED', 'Lichtszenarien', 'Automatisierung'] },
          { title: 'Terrassen & Pergolen', description: 'Außenwohnbereiche, gedacht fürs mediterrane Klima: Schatten im Sommer, Sonne im Winter.', items: ['Zertifiziertes Tropenholz', 'Naturstein', 'Bioklimatische Pergolen'] },
          { title: 'Wassermanagement',     description: 'Nachhaltige Lösungen für Bewässerung und Wassernutzung, an der katalanischen Küste unverzichtbar.', items: ['Regenwassernutzung', 'Intelligente Bewässerung', 'Brunnen & Teiche'] },
        ],
      },
      interieur: {
        breadcrumb: 'Innenausbau',
        heroLabel:  'Innenausbau',
        heroTitle1: 'Innenräume',
        heroTitleItalic: 'auf den Punkt',
        heroSubtitle: 'Ein Innenraum, der funktioniert, bevor er schön ist. Maßtischlerei, Oberflächen, die Lieferant für Lieferant ausgewählt werden, dezente Haustechnik: Wir arbeiten an den Details, weil man mit ihnen jeden Tag lebt.',
        heroCta:    'Mein Interieur gestalten',
        featuresLabel: 'Unsere Stärken',
        featuresTitle: 'Sinn fürs Detail',
        roomsLabel:  'Unsere Angebote',
        roomsTitle:  'Räume nach Maß',
        galleryLabel: 'Unsere Referenzen',
        galleryTitle: 'Ein paar Inspirationen',
        ctaSubtitle: 'Kostenlose Designberatung. Bringen Sie Ihre Referenzen mit, wir besprechen sie gemeinsam.',
        services: [
          { title: 'Maßtischlerarbeiten', description: 'Türen, Fenster, Schränke und Ankleidezimmer, entworfen und gefertigt für Ihren Innenraum, Raum für Raum.', items: ['Massivholz & MDF', 'Zeitgenössisches oder klassisches Design', 'Lackierte oder natürliche Oberflächen'] },
          { title: 'Premium-Oberflächen', description: 'Böden, Wände und Decken aus edlen Materialien, gewählt für die Dauer.', items: ['Massiv- & Fertigparkett', 'Naturstein & Keramik', 'Dekorative Putze'] },
          { title: 'Integrierte Automation', description: 'Gesteuerte Systeme für Komfort und Sicherheit, integriert, ohne den Raum optisch zu überlagern.', items: ['Automatisierte Beleuchtung', 'Zoniertes Klima', 'Vernetzte Sicherheit'] },
          { title: 'Hochwertige Oberflächen', description: 'Auf Dauer machen die Details den Unterschied: saubere Anschlüsse, unsichtbare Übergänge, makelloser Anstrich.', items: ['Ökologische Farben', 'Stuckaturen & Zierleisten', 'Architektonische Beleuchtung'] },
        ],
        rooms: [
          { name: 'Küchen',        desc: 'Italienisches Design, professionelle Geräte' },
          { name: 'Badezimmer',    desc: 'Privater Spa, Design-Armaturen' },
          { name: 'Ankleidezimmer',desc: 'Maßgeschneiderte Organisation, integrierte Beleuchtung' },
          { name: 'Treppen',       desc: 'Holz, Metall oder Glas, je nach Projekt' },
        ],
      },
      maconnerie: {
        breadcrumb: 'Mauerwerk',
        heroLabel:  'Mauerwerk',
        heroTitle1: 'Die Kunst des',
        heroTitleItalic: 'Steins',
        heroSubtitle: 'Unser Maurerteam bearbeitet den Stein so, wie man es in der Region immer getan hat, mit den Werkzeugen von heute. Naturstein, katalanische Gewölbe, Kalkputze: ein Handwerk, das auf der Baustelle weitergegeben wird, nicht in Broschüren.',
        heroCta:    'Mein Projekt besprechen',
        techniquesLabel: 'Unsere Angebote',
        techniquesTitle: 'Traditionelle Techniken',
        servicesLabel:   'Unsere Stärken',
        servicesTitle:   'Vom Fundament bis zur Oberfläche',
        commitmentTitle: 'Unser Versprechen',
        commitmentDesc:  'Unsere Maurerarbeiten werden von unseren internen Teams geführt, die in traditionellen katalanischen Techniken und aktuellen Normen ausgebildet sind.',
        ctaSubtitle: 'Kostenlose Beratung, detailliertes Angebot. Unsere Teams kommen vorbei und prüfen Ihr Projekt.',
        techniques: [
          { title: 'Naturstein',           description: 'Trockensteinmauern, Verkleidung, Opus incertum. Wir arbeiten mit lokalen Steinen aus der Provinz Girona, geliefert von Steinbrüchen, die wir kennen.' },
          { title: 'Katalanische Gewölbe', description: 'Flach verlegte Ziegel, eine Bauweise, die zur Signatur der mediterranen Architektur gehört. Wenige Teams beherrschen sie noch, unseres schon.' },
          { title: 'Dekorativer Beton',    description: 'Polierter, geprägter und gewaschener Beton für Böden und Mauerkronen.' },
        ],
        services: ['Fundament und Tragstruktur', 'Tragende Wände und Trennwände', 'Steintreppen', 'Kamine und Grillplätze', 'Gartenmauern und Einzäunungen', 'Fassadenrestaurierung', 'Traditionelle Putze', 'Verfugung von Sichtstein'],
        commitments: ['Materialien nach Möglichkeit lokal beschafft', 'Respekt vor den katalanischen Handwerkstechniken', 'Zehnjährige Garantie auf alle unsere Arbeiten'],
      },
      piscine: {
        breadcrumb: 'Schwimmbäder',
        heroLabel:  'Schwimmbäder',
        heroTitle1: 'Die Kunst des',
        heroTitleItalic: 'Wassers',
        heroSubtitle: 'Pools, die sich in Gelände und Haus einfügen, statt darauf platziert zu werden. Vom ersten Entwurf bis zur Technik führen wir das Ganze.',
        heroCta:    'Meinen Pool planen',
        featuresLabel: 'Unsere Stärken',
        featuresTitle: 'Technologien & Design',
        typesLabel:  'Unsere Angebote',
        typesTitle:  'Wählen Sie Ihren Stil',
        galleryLabel: 'Unsere Referenzen',
        galleryTitle: 'Ausgewählte Projekte',
        ctaSubtitle: 'Kostenlose Machbarkeitsstudie. Wir prüfen Ihr Grundstück und das, was Sie im Kopf haben.',
        features: [
          { title: 'Infinity-Pool',         description: 'Spiegeleffekt, in die mediterrane Landschaft eingepasst und auf Ihre Aussicht kalibriert.' },
          { title: 'Solarheizung',          description: 'Um die Badesaison zu verlängern, ohne die Energierechnung zu belasten.' },
          { title: 'Naturbehandlung',       description: 'Chloralternativen: Salz, UV oder biologische Becken für weicheres Wasser.' },
          { title: 'Vollautomatisierung',   description: 'Filtration, Heizung, Beleuchtung per Telefon ferngesteuert.' },
        ],
        types: [
          { title: 'Traditioneller Pool', desc: 'Stahlbetonbau, individuelle Abmessungen, Fliesen- oder Linerbeschichtung.', size: '8×4 m' },
          { title: 'Infinity-Pool',       desc: 'Spiegeleffekt und visuelle Fortsetzung der Landschaft.', size: '10×5 m' },
          { title: 'Biologischer Pool',   desc: 'Naturbecken mit pflanzlicher Regenerationszone.', size: '12×6 m' },
        ],
      },
    },
  },

  // ── ESPAÑOL ────────────────────────────────────────────────────────────────
  es: {
    nav: {
      services: 'Servicios',
      projects: 'Proyectos',
      forSale:  'En venta',
      about:    'Nuestra historia',
      news:     'Noticias',
      contact:  'Contacto',
      cta:      'Presupuesto gratuito',
    },
    hero: {
      label:    'Platja d\'Aro · Costa Brava',
      title:    ['Construir', 'lo esencial.'],
      subtitle: 'Una empresa de construcción alemana instalada en la Costa Brava. Un interlocutor, un plazo respetado, una obra acompañada de principio a fin.',
      cta1:     'Descubrir nuestros proyectos',
      cta2:     'Presupuesto gratuito',
      scroll:   'Deslizar',
    },
    stats: [
      { value: '100+', label: 'Proyectos realizados'  },
      { value: '5',    label: 'Años de experiencia'   },
      { value: '4',    label: 'Idiomas hablados'      },
      { value: '100%', label: 'Recomendaciones'       },
    ],
    story: {
      label:  'Nuestra historia',
      quote:  'Lo que siempre me ha guiado es entender lo que el cliente realmente quiere, y entregarlo a tiempo.',
      author: '— Sebastian Lemke, fundador',
      title:  'La exigencia del automóvil,\naplicada a su hogar.',
      p1:     'Antes de la Costa Brava, Sebastian Lemke pasó años en las grandes marcas automovilísticas alemanas. Una escuela exigente, donde se aprende a entregar en plazo y sin aproximaciones. Después la región lo retuvo.',
      p2:     'Se instala en Platja d\'Aro y funda Construcciones Remalex S.L. en torno a una idea sencilla: una casa debe construirse con el mismo cuidado que un coche de serie de gama alta.',
      cta:    'Nuestra historia completa',
    },
    services: {
      label:   'Nuestros servicios',
      title:   'Seis oficios, un solo equipo',
      viewAll: 'Ver todos los servicios',
      items: [
        { name: 'Construcción nueva',      desc: 'Villas a medida, desde el primer boceto hasta la entrega de llaves.',                      link: '/services/construction' },
        { name: 'Renovación',              desc: 'Transformación completa o parcial, sin desvirtuar la construcción existente.',             link: '/services/renovation'   },
        { name: 'Interiorismo',            desc: 'Carpintería a medida, acabados cuidados, domótica integrada.',                              link: '/services/interieur'    },
        { name: 'Espacios exteriores',     desc: 'Jardines, terrazas e iluminación pensados como prolongación del salón.',                    link: '/services/exterieur'    },
        { name: 'Piscinas',                desc: 'Infinity, naturales o automatizadas: cada proyecto se dibuja para el terreno.',             link: '/services/piscine'      },
        { name: 'Mampostería de piedra',   desc: 'Piedra catalana trabajada a mano. Bóvedas, muros de carga, escaleras.',                    link: '/services/maconnerie'   },
      ],
    },
    partnership: {
      label: 'Ecosistema completo',
      title: 'Construir, gestionar, valorizar.',
      desc:  'Trabajamos en asociación exclusiva con Solenca, que toma el relevo una vez entregada la casa: gestión de alquileres, conserjería, mantenimiento. Construcciones Remalex construye, Solenca se ocupa de lo que viene después. Un único ecosistema para una inversión en la Costa Brava.',
      tag1:  'Construcción & Renovación',
      tag2:  'Property Management',
      cta:   'Descubrir Solenca',
    },
    testimonial: {
      quote:    'Sebastian y su equipo convirtieron nuestra masía catalana en una verdadera villa familiar. Rigor alemán sobre construcción catalana: no imaginábamos un resultado a este nivel.',
      author:   'Thomas & Anna H.',
      location: 'Platja d\'Aro · Clientes desde 2022',
    },
    cta: {
      title:    '¿Tiene un proyecto en mente?',
      subtitle: 'La primera conversación es gratuita. Podemos hablarlo tomando un café en Platja d\'Aro, o por teléfono si está más lejos.',
      btn1:     'Contacta con nosotros',
      btn2:     '+34 602 645 005',
    },
    footer: {
      tagline:      'Your house in our care.',
      servicesTitle:'Servicios',
      navTitle:     'Navegación',
      contactTitle: 'Contacto',
      address:      "Carrer dels Avets 5\nCastell d'Aro, Girona",
      hours:        'Lun – Dom: 9:00 – 17:00',
      legal:        'Aviso legal',
      cookies:      'Cookies',
      privacy:      'Política de privacidad',
      rights:       'Todos los derechos reservados.',
      developedBy:  'Desarrollado por',
      adminTooltip: 'Área de administración',
      adminLabel:   'Admin',
      navLinks: [
        { label: 'Inicio',           to: '/'                 },
        { label: 'Servicios',        to: '/services'         },
        { label: 'Proyectos',        to: '/realisations'     },
        { label: 'En venta',         to: '/projets-en-vente' },
        { label: 'Nuestra historia', to: '/a-propos'         },
        { label: 'Socios',           to: '/partenaires'      },
        { label: 'Contacto',         to: '/contact'          },
      ],
    },
    about: {
      heroLabel:   'Sobre nosotros',
      heroTitle:   'Construir lo esencial.',
      heroSub:     'Construcciones Remalex S.L., construcción y renovación en la Costa Brava desde 2021.',
      storyLabel:  'Nuestro ADN',
      storyTitle:  'El rigor alemán,\nal servicio de la vivienda española.',
      storyP1:     'Antes de instalarse en la Costa Brava, Sebastian Lemke hizo su carrera en los grandes grupos automovilísticos alemanes. Entró por el terreno y recorrió todos los escalones de las ventas hasta convertirse en una figura reconocida del sector. Su cualidad principal: saber escuchar lo que un cliente busca de verdad, a veces antes de que sepa formularlo.',
      storyP2:     'En 2021 funda su empresa de construcción en Platja d\'Aro. La idea es sencilla: aplicar en España los métodos de trabajo que conoce. Se rodea de artesanos instalados en la región y mantiene una regla estricta, el respeto de los plazos acordados.',
      storyP3:     'En 2026 la sociedad se reorganiza. CasaCare Remalex pasa a llamarse Construcciones Remalex S.L., y la rama de mantenimiento se transfiere a Solenca, socio de toda la vida. Sebastian puede entonces concentrarse en lo que le interesa desde el principio, la construcción y la renovación.',
      valuesLabel: 'Nuestros valores',
      valuesTitle: 'Lo que nos guía',
      values: [
        { num: '01', title: 'Exigencia',  desc: 'Aplicamos a la obra los métodos de una línea de producción alemana: tolerancias estrechas, control en cada etapa, nada sale a medio hacer.' },
        { num: '02', title: 'Proximidad', desc: 'Sebastian sigue personalmente cada obra. Un único interlocutor, accesible en alemán, francés, inglés o español.' },
        { num: '03', title: 'Confianza',  desc: 'Presupuestos detallados, planificación compartida, facturas de proveedores a petición. Usted sabe a dónde va cada euro.' },
        { num: '04', title: 'Respeto',    desc: 'Respeto por el lugar, por la construcción existente, por sus gustos y por el paisaje catalán en el que se inscribe la casa.' },
      ],
      founderLabel: 'El fundador',
      founderTitle: 'Dr. h.c. Sebastian Lemke',
      founderRole:  'Fundador y Director General',
      founderBio1:  'Sebastian Lemke hizo toda su carrera comercial en los grandes fabricantes alemanes de automóviles, hasta convertirse en una de las figuras reconocidas del sector. Su fuerza: entender pronto lo que busca su interlocutor y darle una respuesta concreta, sin palabrería.',
      founderBio2:  'Políglota (alemán, francés, español, inglés), ha traído a la Costa Brava el método de la industria automovilística: planificación ajustada, control de calidad en cada etapa, entrega en la fecha prevista. Se apoya en un núcleo de artesanos locales a los que conoce y con los que trabaja desde hace varios años.',
      timelineLabel:'Nuestra historia',
      timelineTitle:'Cinco años de obras',
      timeline: [
        { year: '2021', title: 'Fundación',                  desc: 'Sebastian Lemke funda CasaCare Remalex en Platja d\'Aro. La idea: aplicar al mercado catalán los métodos de trabajo alemanes.' },
        { year: '2022', title: 'Primeros éxitos',            desc: 'Las primeras obras entregadas se hacen notar. La clientela internacional, exigente, recomienda la empresa boca a boca.' },
        { year: '2023', title: 'Asociación con Solenca',     desc: 'Se establece la alianza estratégica con Solenca, que asume la gestión de alquileres y la conserjería una vez entregada la casa.' },
        { year: '2024', title: 'Expansión',                  desc: 'El equipo crece con nuevos artesanos contratados en la región. La empresa lleva en paralelo obras nuevas y renovaciones de envergadura.' },
        { year: '2025', title: '100+ proyectos',             desc: 'Se supera el centenar de obras entregadas. Remalex se asienta como referencia local en construcción y renovación.' },
        { year: '2026', title: 'Construcciones Remalex',     desc: 'Reorganización: la rama de mantenimiento se transfiere a Solenca y la sociedad pasa a llamarse Construcciones Remalex S.L. Sebastian se concentra en la construcción y la renovación.' },
      ],
      certifLabel: 'Certificaciones y garantías',
      certifs: [
        { title: 'Seguro de Responsabilidad Civil', desc: 'Cobertura completa de nuestras obras'    },
        { title: 'Registro Oficial Español',        desc: 'Empresa registrada y certificada'        },
        { title: 'NIF Español',                     desc: 'Cumplimiento fiscal total'               },
      ],
      ctaTitle: 'Hablemos de su proyecto',
      ctaBtn:   'Contacta con nosotros',
    },
    contact: {
      heroLabel: 'Contacto',
      heroTitle: 'Hablemos de su proyecto.',
      heroSub:   'La primera conversación es gratuita. Respondemos en español, francés, inglés y alemán.',
      infoTitle: 'Encuéntrenos',
      form: {
        name:         'Nombre y Apellidos',
        email:        'Email',
        phone:        'Teléfono',
        projectType:  'Tipo de proyecto',
        budget:       'Presupuesto estimado',
        message:      'Describa su proyecto',
        privacy:      'Acepto que mis datos sean utilizados para responder a mi solicitud.',
        submit:       'Enviar mi solicitud',
        success:      '¡Su mensaje ha sido enviado!',
        successSub:   'Le responderemos en menos de 24 horas.',
        projectTypes: [
          { value: 'newBuild',   label: 'Construcción nueva'  },
          { value: 'renovation', label: 'Renovación'          },
          { value: 'pool',       label: 'Piscina'             },
          { value: 'outdoor',    label: 'Espacios exteriores' },
          { value: 'other',      label: 'Otro'                },
        ],
        budgets: [
          { value: '50-100',  label: '50.000 € – 100.000 €'  },
          { value: '100-250', label: '100.000 € – 250.000 €' },
          { value: '250-500', label: '250.000 € – 500.000 €' },
          { value: '500+',    label: '500.000 € +'           },
        ],
      },
    },
    contactPage: {
      addressLabel:    'Dirección',
      phoneLabel:      'Teléfono',
      hoursLabel:      'Horario',
      languagesLabel:  'Idiomas',
      address:         "Carrer dels Avets, 5\n17250 Castell d'Aro, Girona\nCosta Brava, España",
      required:        '* obligatorio',
      emailPlaceholder:'tu@email.com',
      phonePlaceholder:'600 000 000',
      newRequest:      'Nueva solicitud',
      errorGeneric:    'Se ha producido un error.',
    },
    partnersPage: {
      heroLabel:    'Red',
      heroTitle:    'Nuestros Socios.',
      heroSub:      'Construcciones Remalex trabaja con algunos actores seleccionados de la Costa Brava para cubrir toda la cadena, desde la compra y el suelo hasta la gestión del inmueble.',
      ctaLabel:     'Su proyecto',
      visitWebsite: 'Visitar sitio',
      categories: {
        solenca:    'Mantenimiento y Gestión Inmobiliaria',
        lucasFox:   'Agencia Inmobiliaria Premium',
      },
    },
    newsPage: {
      title:       'Noticias',
      subtitle:    'Últimas noticias de Construcciones Remalex',
      readMore:    'Leer más',
      backToList:  'Volver a noticias',
      publishedOn: 'Publicado el',
      empty:       'Aún no hay artículos.',
    },
    servicesPage: {
      hero: {
        label:    'Nuestras Especialidades',
        title:    'Seis oficios bajo un mismo techo.',
        subtitle: 'De la obra nueva a la renovación de envergadura, coordinamos todos los gremios necesarios para su obra en la Costa Brava, sin subcontratar la dirección.',
      },
      learnMore: 'Más información',
      partnership: {
        label:     'Asociación exclusiva',
        title:     'Construir y gestionar, bajo un mismo techo.',
        desc:      'Solenca, agencia inmobiliaria de la Costa Brava, toma el relevo una vez entregada la casa: gestión de alquileres, conserjería, mantenimiento. Construcciones Remalex construye, Solenca se ocupa del resto. Un interlocutor del lado de la obra, uno del lado de la gestión.',
        ecosystem: 'Ecosistema completo',
        tagBadge:  'Construcción + Gestión',
        cta:       'Descubrir Solenca',
      },
      cta: {
        label:    'Su proyecto',
        title:    '¿Lo hablamos?',
        subtitle: 'Una primera cita, sin compromiso, para que entendamos lo que tiene en mente y veamos si podemos ayudarle.',
        btn:      'Contacta con nosotros',
      },
      services: [
        { id: 'construction', num: '01', title: 'Obra Nueva',                tag: 'Villas a medida',          description: "Villas pensadas para su terreno: orientación, vistas, luz, integración en el paisaje de la Costa Brava. Arquitectura contemporánea, vocabulario mediterráneo.", features: ['Arquitectura a medida', 'Materiales seleccionados', 'Seguimiento personalizado de Sebastian'], image: '/images/new-construction.webp' },
        { id: 'renovation',   num: '02', title: 'Renovación',                tag: 'Transformación completa',  description: "Renovar sin desvirtuar. Apartamentos, villas, casas urbanas: conservamos lo que da alma al lugar y ponemos al día el resto (aislamiento, instalaciones, acabados).", features: ['Diagnóstico completo', 'Gestión integral de obra', 'Coordinación de gremios'], image: '/images/renovation.webp' },
        { id: 'masia',        num: '03', title: 'Renovación de Masía',       tag: 'Patrimonio catalán',       description: "Es nuestra especialidad. La masía catalana se renueva con sus propias reglas: piedra vista, bóvedas, vigas antiguas. Las conservamos e inyectamos el confort actual por encima.", features: ['Respeto al patrimonio construido', 'Técnicas tradicionales', 'Confort moderno integrado'], image: '/images/renovation-masia.webp' },
        { id: 'piscine',      num: '04', title: 'Piscinas',                  tag: 'Diseño & Técnica',         description: "Piscinas dibujadas para su terreno: efecto espejo, laguna natural, vaso climatizado. Cada proyecto tiene en cuenta el suelo, el viento y el clima local.", features: ['Diseño personalizado', 'Sistema de filtración de última generación', 'Integración paisajística'], image: '/images/pool.webp' },
        { id: 'exterieur',    num: '05', title: 'Paisajismo',                tag: 'Jardines & Terrazas',      description: "Terrazas, jardines, caminos, zonas de comedor exterior: prolongamos la casa hacia el paisaje catalán, en lugar de enfrentar ambos.", features: ['Diseño paisajístico', 'Pavimentación y terrazas a medida', 'Iluminación arquitectónica'], image: '/images/garden-amenagement.webp' },
        { id: 'maintenance',  num: '06', title: 'Mantenimiento',             tag: 'Seguimiento & Tranquilidad', description: "Con Solenca, nuestro socio especializado en gestión inmobiliaria en la Costa Brava, nos ocupamos del mantenimiento corriente: fontanería, electricidad, jardinería, piscina, conserjería. Usted conserva un único contacto.", features: ['Asociación exclusiva con Solenca', 'Contratos anuales a medida', 'Gestión de alquileres & conserjería'], image: '/solenca-van.webp' },
      ],
    },
    projectsPage: {
      hero: {
        label:       'Realizaciones',
        title1:      'Nuestros',
        titleItalic: 'proyectos.',
        subtitle:    'Una selección de obras entregadas en los últimos años: obra nueva, renovaciones de masía, piscinas, paisajismo.',
      },
      categories: [
        { id: 'all',        label: 'Todos'         },
        { id: 'newBuild',   label: 'Construcción'   },
        { id: 'renovation', label: 'Renovación'     },
        { id: 'pool',       label: 'Piscinas'        },
        { id: 'outdoor',    label: 'Exterior'       },
      ],
      typeLabels: {
        newBuild:   'Construcción',
        renovation: 'Renovación',
        pool:       'Piscina',
        outdoor:    'Exterior',
        masonry:    'Mampostería',
      },
      noResults: 'Ningún proyecto en esta categoría.',
    },
    legalPage: {
      label: 'Legal',
      mentionsTitle: 'Aviso legal',
      privacyTitle:  'Política de privacidad',
    },
    servicePages: {
      breadcrumbBase: 'Servicios',
      ourAssets: 'Nuestras Ventajas',
      ourServices: 'Nuestras Fórmulas',
      ourWork: 'Nuestras Realizaciones',
      yourProject: 'Su proyecto',
      ctaTitle: 'Hablemos de su proyecto',
      ctaBtn: 'Solicitar presupuesto',
      construction: {
        breadcrumb: 'Obra Nueva',
        heroLabel:  'Obra Nueva',
        heroTitle1: 'Casas',
        heroTitleItalic: 'pensadas a medida',
        heroSubtitle: 'Una villa empieza por un terreno. Diseñamos la casa a su alrededor: orientación, vistas, materiales. Arquitectura mediterránea contemporánea, acabados cuidados.',
        heroCta:    'Iniciar mi proyecto',
        featuresLabel: 'Nuestras Ventajas',
        featuresTitle: 'Nuestro método, paso a paso',
        processLabel: 'Proceso',
        processTitle: 'De la idea a la entrega',
        ctaSubtitle: 'Primera reunión gratuita. Visitamos su terreno y comentamos juntos las primeras líneas.',
        features: [
          { title: 'Arquitectura a medida',  description: 'Planos dibujados para su terreno y su manera de vivir. Sin modelos duplicados de una obra a otra.' },
          { title: 'Materiales premium',     description: 'Piedra natural, madera certificada, acero inoxidable: seleccionamos los materiales con usted, proveedor a proveedor.' },
          { title: 'Equipo integrado',       description: 'Arquitectos, ingenieros y artesanos coordinados internamente, sin pelotas que se pasan entre proveedores.' },
          { title: 'Garantía decenal',       description: 'Garantía decenal en la entrega, conforme al derecho español. La obra queda cubierta durante diez años.' },
        ],
        process: [
          { num: '01', title: 'Estudio del terreno',         desc: 'Análisis topográfico, estudio geotécnico, restricciones urbanísticas.' },
          { num: '02', title: 'Diseño arquitectónico',       desc: 'Planos 3D, selección de materiales, optimización energética.' },
          { num: '03', title: 'Permisos y trámites',         desc: 'Gestión completa de las autorizaciones administrativas.' },
          { num: '04', title: 'Construcción',                desc: 'Seguimiento de obra con hitos periódicos y fotos semanales.' },
          { num: '05', title: 'Entrega',                     desc: 'Inspección final y entrega de llaves de su villa.' },
        ],
      },
      renovation: {
        breadcrumb: 'Renovación',
        heroLabel:  'Renovación',
        heroTitle1: 'Transformar,',
        heroTitleItalic: 'sin desvirtuar',
        heroSubtitle: 'Una renovación lograda conserva lo que da carácter al lugar y pone al día el resto: aislamiento, instalaciones, luz, distribución. De masías catalanas a villas contemporáneas.',
        heroCta:    'Evaluar mi proyecto',
        featuresLabel: 'Nuestras Ventajas',
        featuresTitle: 'Por qué elegirnos',
        typesLabel:  'Nuestras Fórmulas',
        typesTitle:  'Soluciones adaptadas',
        ctaSubtitle: 'Diagnóstico gratuito, estimación detallada. Nos desplazamos para ver el inmueble y comentarlo in situ.',
        features: [
          { title: 'Diagnóstico completo',        description: 'Evaluación de la estructura, las instalaciones y el potencial de transformación, antes de cifrar nada.' },
          { title: 'Optimización energética',     description: 'Aislamiento, ventilación, paneles solares: facturas más bajas, mayor confort.' },
          { title: 'Valorización patrimonial',    description: 'Restauración de los elementos originales sin congelarlos: bóvedas catalanas, muros de piedra, baldosas tradicionales.' },
          { title: 'Modernización inteligente',   description: 'Integración discreta de los equipos actuales: domótica, climatización, seguridad.' },
        ],
        types: [
          { title: 'Renovación completa', desc: 'Reforma integral, de la estructura a los acabados.' },
          { title: 'Renovación parcial',  desc: 'Trabajos puntuales: cocina, baños, zonas de vida.' },
          { title: 'Ampliación',          desc: 'Ampliación bien encajada con la construcción existente.' },
        ],
      },
      exterieur: {
        breadcrumb: 'Paisajismo',
        heroLabel:  'Paisajismo',
        heroTitle1: 'Jardines y',
        heroTitleItalic: 'terrazas',
        heroSubtitle: 'Un exterior bien pensado prolonga la casa hacia el paisaje catalán. Diseñamos jardines y terrazas adaptados al clima mediterráneo, al agua que escasea en verano y a su ritmo de vida.',
        heroCta:    'Imaginar mi jardín',
        featuresLabel: 'Nuestras Ventajas',
        featuresTitle: 'Un jardín a medida',
        galleryLabel: 'Nuestras Realizaciones',
        galleryTitle: 'Algunos proyectos',
        ctaSubtitle: 'Consulta paisajística gratuita. Nos desplazamos a ver su exterior y lo comentamos in situ.',
        services: [
          { title: 'Diseño paisajístico', description: 'Jardines mediterráneos, vegetación elegida para resistir los veranos secos de la Costa Brava.', items: ['Planos paisajísticos 3D', 'Selección vegetal', 'Sistemas de riego'] },
          { title: 'Iluminación arquitectónica', description: 'Iluminación discreta del jardín y de la fachada, sin contaminación lumínica.', items: ['LED de bajo consumo', 'Escenarios lumínicos', 'Automatización'] },
          { title: 'Terrazas y pérgolas', description: 'Espacios de vida exteriores pensados para el clima mediterráneo: sombra en verano, sol en invierno.', items: ['Madera tropical certificada', 'Piedra natural', 'Pérgolas bioclimáticas'] },
          { title: 'Gestión del agua',    description: 'Soluciones sostenibles para el riego y la recuperación de agua, imprescindibles en la costa catalana.', items: ['Recogida de agua de lluvia', 'Riego inteligente', 'Fuentes y estanques'] },
        ],
      },
      interieur: {
        breadcrumb: 'Diseño Interior',
        heroLabel:  'Diseño Interior',
        heroTitle1: 'Interiores',
        heroTitleItalic: 'a tiralíneas',
        heroSubtitle: 'Un interior que funciona antes de ser bonito. Carpintería a medida, revestimientos elegidos proveedor a proveedor, domótica discreta: trabajamos los detalles, porque son los que se viven a diario.',
        heroCta:    'Diseñar mi interior',
        featuresLabel: 'Nuestras Ventajas',
        featuresTitle: 'El cuidado del detalle',
        roomsLabel:  'Nuestras Fórmulas',
        roomsTitle:  'Estancias a medida',
        galleryLabel: 'Nuestras Realizaciones',
        galleryTitle: 'Algunas inspiraciones',
        ctaSubtitle: 'Consulta de diseño gratuita. Traiga sus referencias, lo comentamos juntos.',
        services: [
          { title: 'Carpintería a medida',     description: 'Puertas, ventanas, armarios y vestidores diseñados y fabricados para su interior, estancia a estancia.', items: ['Madera maciza y MDF', 'Diseño contemporáneo o clásico', 'Acabados lacados o naturales'] },
          { title: 'Revestimientos premium',   description: 'Suelos, paredes y techos con materiales nobles, elegidos para durar.', items: ['Parquet macizo & multicapa', 'Piedra natural & cerámica', 'Estucos decorativos'] },
          { title: 'Domótica integrada',       description: 'Sistemas controlados para el confort y la seguridad, integrados sin invadir el espacio visual.', items: ['Iluminación automatizada', 'Climatización por zonas', 'Seguridad conectada'] },
          { title: 'Acabados de alta gama',    description: 'Son los detalles los que marcan la diferencia a largo plazo: encuentros limpios, juntas invisibles, pintura sin defecto.', items: ['Pinturas ecológicas', 'Escayolas y molduras', 'Iluminación arquitectónica'] },
        ],
        rooms: [
          { name: 'Cocinas',     desc: 'Diseño italiano, equipamiento profesional' },
          { name: 'Baños',       desc: 'Spa privado, grifería de diseño' },
          { name: 'Vestidores',  desc: 'Organización a medida, iluminación integrada' },
          { name: 'Escaleras',   desc: 'Madera, metal o vidrio, según el proyecto' },
        ],
      },
      maconnerie: {
        breadcrumb: 'Mampostería',
        heroLabel:  'Mampostería',
        heroTitle1: 'El arte de',
        heroTitleItalic: 'la piedra',
        heroSubtitle: 'Nuestro equipo de albañiles trabaja la piedra como siempre se ha hecho en la región, con las herramientas de hoy. Piedra natural, bóvedas catalanas, revoques de cal: un oficio que se transmite en la obra, no en los folletos.',
        heroCta:    'Hablar de mi proyecto',
        techniquesLabel: 'Nuestras Fórmulas',
        techniquesTitle: 'Técnicas tradicionales',
        servicesLabel:   'Nuestras Ventajas',
        servicesTitle:   'De los cimientos a los acabados',
        commitmentTitle: 'Nuestro compromiso',
        commitmentDesc:  'Nuestras obras de mampostería las llevan nuestros equipos internos, formados en las técnicas tradicionales catalanas y en la normativa vigente.',
        ctaSubtitle: 'Consulta gratuita, presupuesto detallado. Nuestros equipos se desplazan para estudiar su proyecto.',
        techniques: [
          { title: 'Piedra natural',       description: 'Muros de piedra seca, aplacado, opus incertum. Trabajamos con piedras locales de Girona, suministradas por canteras que conocemos.' },
          { title: 'Bóvedas catalanas',    description: 'Técnica de construcción con ladrillos colocados de plano, firma de la arquitectura mediterránea. Pocos equipos siguen dominándola, el nuestro sí.' },
          { title: 'Hormigón decorativo',  description: 'Hormigón pulido, impreso y lavado para suelos y muretes.' },
        ],
        services: ['Cimentación y estructura', 'Muros de carga y tabiques', 'Escaleras de piedra', 'Chimeneas y barbacoas', 'Muretes y cerramientos', 'Restauración de fachadas', 'Revoques tradicionales', 'Rejuntado de piedra vista'],
        commitments: ['Materiales de origen local siempre que sea posible', 'Respeto a las técnicas tradicionales catalanas', 'Garantía decenal en todos nuestros trabajos'],
      },
      piscine: {
        breadcrumb: 'Piscinas',
        heroLabel:  'Piscinas',
        heroTitle1: 'El arte del',
        heroTitleItalic: 'agua',
        heroSubtitle: 'Piscinas dibujadas para integrarse en el terreno y la casa, en lugar de quedar encima. Desde el dibujo inicial hasta los equipos técnicos, llevamos el conjunto.',
        heroCta:    'Diseñar mi piscina',
        featuresLabel: 'Nuestras Ventajas',
        featuresTitle: 'Tecnologías & Diseño',
        typesLabel:  'Nuestras Fórmulas',
        typesTitle:  'Elija su estilo',
        galleryLabel: 'Nuestras Realizaciones',
        galleryTitle: 'Algunos proyectos',
        ctaSubtitle: 'Estudio de viabilidad gratuito. Analizamos su terreno y lo que tiene en mente.',
        features: [
          { title: 'Piscina desbordante', description: 'Efecto espejo integrado en el paisaje mediterráneo, calibrado para sus vistas.' },
          { title: 'Calefacción solar',   description: 'Para alargar la temporada de baño sin cargar la factura energética.' },
          { title: 'Tratamiento natural', description: 'Alternativas al cloro: sal, UV o piscinas biológicas para un agua más suave.' },
          { title: 'Automatización completa', description: 'Filtración, calefacción e iluminación controladas a distancia desde el móvil.' },
        ],
        types: [
          { title: 'Piscina tradicional', desc: 'Construcción en hormigón armado, dimensiones personalizadas, acabado en azulejo o liner.', size: '8×4 m' },
          { title: 'Piscina desbordante', desc: 'Efecto espejo y continuidad visual con el paisaje.', size: '10×5 m' },
          { title: 'Piscina biológica',   desc: 'Estanque natural con zona de regeneración vegetal.', size: '12×6 m' },
        ],
      },
    },
  },

  // ── РУССКИЙ ────────────────────────────────────────────────────────────────
  ru: {
    nav: {
      services: 'Услуги',
      projects: 'Проекты',
      forSale:  'На продажу',
      about:    'О нас',
      news:     'Новости',
      contact:  'Контакт',
      cta:      'Бесплатная смета',
    },
    hero: {
      label:    'Platja d\'Aro · Коста-Брава',
      title:    ['Строить', 'главное.'],
      subtitle: 'Немецкая строительная компания на Коста-Браве. Один контактный человек, соблюдаемый график, объект, который ведут от начала до конца.',
      cta1:     'Посмотреть наши проекты',
      cta2:     'Бесплатная смета',
      scroll:   'Прокрутить',
    },
    stats: [
      { value: '100+', label: 'Завершённых проектов' },
      { value: '5',    label: 'Лет опыта'            },
      { value: '5',    label: 'языков'               },
      { value: '100%', label: 'Рекомендаций'         },
    ],
    story: {
      label:  'Наша история',
      quote:  'Меня всегда вёл один принцип: понять, чего клиент действительно хочет, и сделать это в срок.',
      author: '— Sebastian Lemke, основатель',
      title:  'Стандарты автопрома,\nприменённые к вашему дому.',
      p1:     'До Коста-Бравы Sebastian Lemke провёл годы в крупных немецких автомобильных концернах. Требовательная школа, где учатся сдавать в срок и без приблизительности. Затем регион удержал его.',
      p2:     'Он обосновался в Platja d\'Aro и основал Construcciones Remalex S.L. вокруг простой идеи: дом должен строиться с той же тщательностью, что и серийный автомобиль высокого класса.',
      cta:    'Вся наша история',
    },
    services: {
      label:   'Наши услуги',
      title:   'Шесть направлений, одна команда',
      viewAll: 'Все услуги',
      items: [
        { name: 'Новое строительство', desc: 'Виллы по индивидуальному проекту, от первого эскиза до сдачи ключей.',                          link: '/services/construction' },
        { name: 'Реновация',           desc: 'Полное или частичное преобразование без изменения характера существующей постройки.',          link: '/services/renovation'   },
        { name: 'Дизайн интерьера',    desc: 'Столярные изделия на заказ, аккуратные отделки, встроенная автоматика дома.',                   link: '/services/interieur'    },
        { name: 'Ландшафтный дизайн',  desc: 'Сады, террасы и освещение, продуманные как продолжение гостиной.',                              link: '/services/exterieur'    },
        { name: 'Бассейны',            desc: 'Инфинити, природные или автоматизированные: каждый проект рисуется под участок.',               link: '/services/piscine'      },
        { name: 'Каменная кладка',     desc: 'Каталонский камень, обработанный вручную. Своды, несущие стены, лестницы.',                     link: '/services/maconnerie'   },
      ],
    },
    partnership: {
      label: 'Полная экосистема',
      title: 'Строить, управлять, повышать ценность.',
      desc:  'Мы работаем в эксклюзивном партнёрстве с Solenca, которая принимает дом после сдачи: управление арендой, консьерж-сервис, обслуживание. Construcciones Remalex строит, Solenca занимается дальнейшим. Одна экосистема для инвестиции на Коста-Браве.',
      tag1:  'Строительство и реновация',
      tag2:  'Управление недвижимостью',
      cta:   'Узнать о Solenca',
    },
    testimonial: {
      quote:    'Sebastian и его команда превратили нашу каталонскую масию в настоящую семейную виллу. Немецкая аккуратность, наложенная на каталонскую постройку: такого результата мы не ожидали.',
      author:   'Томас и Анна Х.',
      location: 'Platja d\'Aro · Клиенты с 2022 года',
    },
    cta: {
      title:    'Есть проект на уме?',
      subtitle: 'Первый разговор бесплатный. Можем обсудить за чашкой кофе в Platja d\'Aro, или по телефону, если Вы далеко.',
      btn1:     'Связаться с нами',
      btn2:     '+34 602 645 005',
    },
    footer: {
      tagline:      'Your house in our care.',
      servicesTitle:'Услуги',
      navTitle:     'Навигация',
      contactTitle: 'Контакт',
      address:      "Carrer dels Avets 5\nCastell d'Aro, Жирона",
      hours:        'Пн – Вс: 9:00 – 17:00',
      legal:        'Правовая информация',
      cookies:      'Cookies',
      privacy:      'Конфиденциальность',
      rights:       'Все права защищены.',
      developedBy:  'Разработано',
      adminTooltip: 'Панель администратора',
      adminLabel:   'Админ',
      navLinks: [
        { label: 'Главная',      to: '/'                 },
        { label: 'Услуги',       to: '/services'         },
        { label: 'Проекты',      to: '/realisations'     },
        { label: 'На продажу',   to: '/projets-en-vente' },
        { label: 'О нас',        to: '/a-propos'         },
        { label: 'Партнёры',     to: '/partenaires'      },
        { label: 'Контакт',      to: '/contact'          },
      ],
    },
    about: {
      heroLabel:   'О компании',
      heroTitle:   'Строить главное.',
      heroSub:     'Construcciones Remalex S.L., строительство и реновация на Коста-Браве с 2021 года.',
      storyLabel:  'Наша ДНК',
      storyTitle:  'Немецкая аккуратность\nна службе испанского жилья.',
      storyP1:     'До того как оказаться на Коста-Браве, Sebastian Lemke сделал карьеру в крупных немецких автомобильных концернах. Он пришёл в продажи с поля и прошёл все ступени, став узнаваемой фигурой в сбыте отрасли. Его главное качество: умение услышать, чего клиент ищет на самом деле, иногда до того, как тот сам это сформулирует.',
      storyP2:     'В 2021 году он открывает свою строительную компанию в Platja d\'Aro. Идея простая: применить в Испании те методы работы, которые он знает. Он собирает мастеров, живущих в регионе, и держится строгого правила, соблюдения заявленных сроков.',
      storyP3:     'В 2026 году компания реорганизуется. CasaCare Remalex становится Construcciones Remalex S.L., а направление обслуживания переходит в Solenca, давнего партнёра. Sebastian может тогда сосредоточиться на том, что интересовало его с самого начала: строительстве и реновации.',
      valuesLabel: 'Наши ценности',
      valuesTitle: 'Что нас ведёт',
      values: [
        { num: '01', title: 'Требовательность', desc: 'Мы применяем к строительству методы немецкой производственной линии: жёсткие допуски, контроль на каждом этапе, ничто не покидает площадку наполовину сделанным.' },
        { num: '02', title: 'Близость',         desc: 'Sebastian лично сопровождает каждый объект. Один контактный человек, доступный на немецком, французском, английском или испанском.' },
        { num: '03', title: 'Доверие',          desc: 'Подробные сметы, общий график, счета поставщиков по запросу. Вы знаете, куда уходит каждый евро.' },
        { num: '04', title: 'Уважение',         desc: 'Уважение к месту, к существующей постройке, к Вашим вкусам и к каталонскому пейзажу, в который вписан дом.' },
      ],
      founderLabel: 'Основатель',
      founderTitle: 'Dr. h.c. Sebastian Lemke',
      founderRole:  'Основатель и генеральный директор',
      founderBio1:  'Sebastian Lemke провёл всю свою коммерческую карьеру у ведущих немецких автопроизводителей, став одной из известных фигур отрасли. Его сила: быстро понять, что ищет собеседник, и дать конкретный ответ, без лишних слов.',
      founderBio2:  'Полиглот (немецкий, французский, испанский, английский), он перенёс на Коста-Браву метод автомобильной промышленности: плотный график, контроль качества на каждом этапе, сдача в назначенный срок. Он опирается на ядро местных мастеров, которых знает и с которыми работает уже несколько лет.',
      timelineLabel:'Наша история',
      timelineTitle:'Пять лет объектов',
      timeline: [
        { year: '2021', title: 'Основание',                   desc: 'Sebastian Lemke основывает CasaCare Remalex в Platja d\'Aro. Идея: применить к каталонскому рынку немецкие методы работы.' },
        { year: '2022', title: 'Первые успехи',               desc: 'Первые сданные объекты обращают на себя внимание. Требовательная международная клиентура рекомендует компанию из уст в уста.' },
        { year: '2023', title: 'Партнёрство с Solenca',       desc: 'Создаётся стратегическое партнёрство с Solenca, которая берёт на себя управление арендой и консьерж-сервис после сдачи дома.' },
        { year: '2024', title: 'Расширение',                  desc: 'Команда растёт за счёт новых мастеров, нанятых в регионе. Компания параллельно ведёт новые стройки и крупные реновации.' },
        { year: '2025', title: '100+ проектов',               desc: 'Преодолена отметка в сто сданных объектов. Remalex закрепляется как местный ориентир в строительстве и реновации.' },
        { year: '2026', title: 'Construcciones Remalex',      desc: 'Реорганизация: направление обслуживания передаётся Solenca, а компания переименовывается в Construcciones Remalex S.L. Sebastian сосредоточивается на строительстве и реновации.' },
      ],
      certifLabel: 'Сертификаты и гарантии',
      certifs: [
        { title: 'Профессиональное страхование ГО', desc: 'Полное покрытие всех наших объектов'  },
        { title: 'Официальный испанский реестр',    desc: 'Зарегистрированная и сертифицированная компания' },
        { title: 'Испанский NIF',                   desc: 'Полное соответствие налоговому законодательству' },
      ],
      ctaTitle: 'Обсудим Ваш проект',
      ctaBtn:   'Связаться с нами',
    },
    contact: {
      heroLabel: 'Контакт',
      heroTitle: 'Обсудим Ваш проект.',
      heroSub:   'Первая консультация бесплатна. Отвечаем на русском, немецком, французском, испанском и английском.',
      infoTitle: 'Как нас найти',
      form: {
        name:         'Имя и фамилия',
        email:        'Email',
        phone:        'Телефон',
        projectType:  'Тип проекта',
        budget:       'Примерный бюджет',
        message:      'Опишите Ваш проект',
        privacy:      'Я согласен на обработку моих данных для ответа на мой запрос.',
        submit:       'Отправить запрос',
        success:      'Ваше сообщение отправлено!',
        successSub:   'Мы ответим в течение 24 часов.',
        projectTypes: [
          { value: 'newBuild',   label: 'Новое строительство'   },
          { value: 'renovation', label: 'Реновация'             },
          { value: 'pool',       label: 'Бассейн'               },
          { value: 'outdoor',    label: 'Ландшафтный дизайн'    },
          { value: 'other',      label: 'Другое'                },
        ],
        budgets: [
          { value: '50-100',  label: '50 000 € – 100 000 €'  },
          { value: '100-250', label: '100 000 € – 250 000 €' },
          { value: '250-500', label: '250 000 € – 500 000 €' },
          { value: '500+',    label: 'от 500 000 €'          },
        ],
      },
    },
    contactPage: {
      addressLabel:    'Адрес',
      phoneLabel:      'Телефон',
      hoursLabel:      'Часы работы',
      languagesLabel:  'Языки',
      address:         "Carrer dels Avets, 5\n17250 Castell d'Aro, Жирона\nКоста-Брава, Испания",
      required:        '* обязательно',
      emailPlaceholder:'ваш@email.com',
      phonePlaceholder:'600 000 000',
      newRequest:      'Новый запрос',
      errorGeneric:    'Произошла ошибка.',
    },
    partnersPage: {
      heroLabel:    'Сеть',
      heroTitle:    'Наши партнёры.',
      heroSub:      'Construcciones Remalex работает с несколькими выбранными игроками Коста-Бравы, чтобы покрыть всю цепочку, от покупки и земли до управления объектом.',
      ctaLabel:     'Ваш проект',
      visitWebsite: 'Перейти на сайт',
      categories: {
        solenca:    'Обслуживание и управление недвижимостью',
        lucasFox:   'Премиальное агентство недвижимости',
      },
    },
    newsPage: {
      title:       'Новости',
      subtitle:    'Последние новости Construcciones Remalex',
      readMore:    'Читать далее',
      backToList:  'Назад к новостям',
      publishedOn: 'Опубликовано',
      empty:       'Пока нет статей.',
    },
    servicesPage: {
      hero: {
        label:    'Наши специализации',
        title:    'Шесть направлений под одной крышей.',
        subtitle: 'От нового строительства до крупной реновации мы координируем все необходимые специальности для Вашего объекта на Коста-Браве, не передавая руководство стройкой на сторону.',
      },
      learnMore: 'Подробнее',
      partnership: {
        label:     'Эксклюзивное партнёрство',
        title:     'Строить и управлять под одной крышей.',
        desc:      'Solenca, агентство недвижимости на Коста-Браве, принимает дом после сдачи: управление арендой, консьерж-сервис, обслуживание. Construcciones Remalex строит, Solenca занимается остальным. Один контакт со стороны стройки, один со стороны управления.',
        ecosystem: 'Полная экосистема',
        tagBadge:  'Строительство + Управление',
        cta:       'Узнать о Solenca',
      },
      cta: {
        label:    'Ваш проект',
        title:    'Обсудим?',
        subtitle: 'Первая встреча без обязательств, чтобы мы поняли, что Вы задумали, и посмотрели, можем ли помочь.',
        btn:      'Связаться с нами',
      },
      services: [
        { id: 'construction', num: '01', title: 'Новое строительство', tag: 'Виллы по индивидуальному проекту', description: "Виллы, продуманные под участок: ориентация, виды, свет, вписывание в пейзаж Коста-Бравы. Современная архитектура, средиземноморский язык.", features: ['Индивидуальная архитектура', 'Отборные материалы', 'Личный контроль Sebastian'], image: '/images/new-construction.webp' },
        { id: 'renovation',   num: '02', title: 'Реновация',           tag: 'Полное преображение',    description: "Обновить, не теряя характера. Квартиры, виллы, городские дома: сохраняем то, что задаёт характер места, и приводим остальное к современному уровню (утепление, инженерные сети, отделка).", features: ['Полная диагностика', 'Комплексное управление строительством', 'Координация подрядчиков'], image: '/images/renovation.webp' },
        { id: 'masia',        num: '03', title: 'Реновация масии',     tag: 'Каталонское наследие',   description: "Это наша специализация. Каталонская масия реставрируется по собственным правилам: открытый камень, своды, старые балки. Мы их сохраняем и поверх вводим современный комфорт.", features: ['Сохранение исторического облика', 'Традиционные техники', 'Современный комфорт'], image: '/images/renovation-masia.webp' },
        { id: 'piscine',      num: '04', title: 'Бассейны',            tag: 'Дизайн & Технологии',    description: "Бассейны, нарисованные под участок: зеркальный эффект, природная лагуна, подогреваемая чаша. Каждый проект учитывает почву, ветер и местный климат.", features: ['Индивидуальный дизайн', 'Система фильтрации последнего поколения', 'Ландшафтная интеграция'], image: '/images/pool.webp' },
        { id: 'exterieur',    num: '05', title: 'Ландшафтный дизайн',  tag: 'Сады & Террасы',         description: "Террасы, сады, дорожки, зоны для еды на улице: мы продолжаем дом в каталонский пейзаж, а не противопоставляем одно другому.", features: ['Ландшафтный проект', 'Мощение и террасы на заказ', 'Архитектурное освещение'], image: '/images/garden-amenagement.webp' },
        { id: 'maintenance',  num: '06', title: 'Техническое обслуживание', tag: 'Уход & Покой',      description: "Вместе с Solenca, нашим партнёром по управлению недвижимостью на Коста-Браве, мы берём на себя текущее обслуживание: сантехника, электрика, садоводство, бассейн, консьерж-сервис. У Вас остаётся один контакт.", features: ['Эксклюзивное партнёрство с Solenca', 'Индивидуальные годовые контракты', 'Управление арендой & консьерж'], image: '/solenca-van.webp' },
      ],
    },
    projectsPage: {
      hero: {
        label:       'Реализации',
        title1:      'Наши',
        titleItalic: 'проекты.',
        subtitle:    'Подборка объектов, сданных за последние годы: новое строительство, реновации масий, бассейны, ландшафт.',
      },
      categories: [
        { id: 'all',        label: 'Все'              },
        { id: 'newBuild',   label: 'Строительство'    },
        { id: 'renovation', label: 'Реновация'        },
        { id: 'pool',       label: 'Бассейны'         },
        { id: 'outdoor',    label: 'Открытые зоны'    },
      ],
      typeLabels: {
        newBuild:   'Строительство',
        renovation: 'Реновация',
        pool:       'Бассейн',
        outdoor:    'Открытые зоны',
        masonry:    'Кладка',
      },
      noResults: 'Проектов в этой категории нет.',
    },
    legalPage: {
      label: 'Правовая информация',
      mentionsTitle: 'Правовая информация',
      privacyTitle:  'Политика конфиденциальности',
    },
    servicePages: {
      breadcrumbBase: 'Услуги',
      ourAssets: 'Наши преимущества',
      ourServices: 'Наши предложения',
      ourWork: 'Наши работы',
      yourProject: 'Ваш проект',
      ctaTitle: 'Обсудим ваш проект',
      ctaBtn: 'Запросить смету',
      construction: {
        breadcrumb: 'Новое строительство',
        heroLabel:  'Новое строительство',
        heroTitle1: 'Дома',
        heroTitleItalic: 'по индивидуальному проекту',
        heroSubtitle: 'Вилла начинается с участка. Мы проектируем дом вокруг него: ориентация, виды, материалы. Современная средиземноморская архитектура, аккуратные отделки.',
        heroCta:    'Начать мой проект',
        featuresLabel: 'Наши преимущества',
        featuresTitle: 'Наш метод, шаг за шагом',
        processLabel: 'Процесс',
        processTitle: 'От идеи к сдаче',
        ctaSubtitle: 'Первая встреча бесплатна. Смотрим Ваш участок и вместе обсуждаем первые направления.',
        features: [
          { title: 'Индивидуальная архитектура', description: 'Планы, нарисованные под Ваш участок и Ваш образ жизни. Без типовых решений, переносимых с одного объекта на другой.' },
          { title: 'Материалы премиум-класса',  description: 'Природный камень, сертифицированное дерево, нержавеющая сталь: материалы подбираем вместе с Вами, поставщик за поставщиком.' },
          { title: 'Слаженная команда',         description: 'Архитекторы, инженеры и мастера координируются внутри компании, без перекидывания ответственности между подрядчиками.' },
          { title: 'Десятилетняя гарантия',     description: 'Десятилетняя гарантия при сдаче по испанскому праву. Объект покрыт в течение десяти лет.' },
        ],
        process: [
          { num: '01', title: 'Изучение участка',          desc: 'Топографический анализ, геологические изыскания, градостроительные ограничения.' },
          { num: '02', title: 'Архитектурное проектирование', desc: '3D-планы, выбор материалов, энергетическая оптимизация.' },
          { num: '03', title: 'Разрешения и согласования', desc: 'Комплексное ведение административных процедур.' },
          { num: '04', title: 'Строительство',             desc: 'Сопровождение объекта с регулярными контрольными точками и еженедельными фотографиями.' },
          { num: '05', title: 'Сдача объекта',             desc: 'Финальная инспекция и передача ключей от Вашей виллы.' },
        ],
      },
      renovation: {
        breadcrumb: 'Реновация',
        heroLabel:  'Реновация',
        heroTitle1: 'Преобразить,',
        heroTitleItalic: 'не теряя характера',
        heroSubtitle: 'Удачная реновация сохраняет то, что задаёт характер места, и приводит остальное к современному уровню: утепление, инженерные сети, свет, планировка. От каталонских масий до современных вилл.',
        heroCta:    'Оценить мой проект',
        featuresLabel: 'Наши преимущества',
        featuresTitle: 'Почему выбирают нас',
        typesLabel:  'Наши предложения',
        typesTitle:  'Адаптированные решения',
        ctaSubtitle: 'Бесплатная диагностика, подробная оценка. Приезжаем посмотреть объект и обсудить его на месте.',
        features: [
          { title: 'Полная диагностика',         description: 'Оценка конструкции, инженерных систем и потенциала преобразования до составления сметы.' },
          { title: 'Энергетическая оптимизация', description: 'Утепление, вентиляция, солнечные панели: ниже счета, выше комфорт.' },
          { title: 'Сохранение исторических элементов', description: 'Реставрация оригинальных элементов без их застывания: каталонские своды, каменные стены, терракота.' },
          { title: 'Умная модернизация',          description: 'Ненавязчивая интеграция современной техники: умный дом, климат-контроль, безопасность.' },
        ],
        types: [
          { title: 'Полная реновация',    desc: 'Полный пересмотр, от конструкции до отделки.' },
          { title: 'Частичная реновация', desc: 'Целевые работы: кухня, ванные, жилые зоны.' },
          { title: 'Расширение',          desc: 'Пристройка, аккуратно увязанная с существующей постройкой.' },
        ],
      },
      exterieur: {
        breadcrumb: 'Ландшафтный дизайн',
        heroLabel:  'Ландшафтный дизайн',
        heroTitle1: 'Сады и',
        heroTitleItalic: 'террасы',
        heroSubtitle: 'Хорошо продуманный сад продолжает дом в каталонский пейзаж. Мы рисуем сады и террасы под средиземноморский климат, под нехватку воды летом и под Ваш ритм жизни.',
        heroCta:    'Проектировать мой сад',
        featuresLabel: 'Наши преимущества',
        featuresTitle: 'Сад на заказ',
        galleryLabel: 'Наши работы',
        galleryTitle: 'Избранные проекты',
        ctaSubtitle: 'Бесплатная ландшафтная консультация. Выезжаем посмотреть Ваш участок и обсудить его на месте.',
        services: [
          { title: 'Ландшафтное проектирование', description: 'Средиземноморские сады, растения, выбранные так, чтобы выдерживать сухое лето Коста-Бравы.', items: ['3D-ландшафтные планы', 'Подбор растений', 'Системы орошения'] },
          { title: 'Архитектурное освещение',    description: 'Деликатная подсветка сада и фасада, без светового загрязнения.', items: ['Энергосберегающий LED', 'Световые сценарии', 'Автоматизация'] },
          { title: 'Террасы и перголы',          description: 'Открытые жилые зоны под средиземноморский климат: тень летом, солнце зимой.', items: ['Сертифицированная тропическая древесина', 'Природный камень', 'Биоклиматические перголы'] },
          { title: 'Управление водой',           description: 'Устойчивые решения по поливу и сбору воды, без которых на каталонском побережье не обойтись.', items: ['Сбор дождевой воды', 'Умный полив', 'Фонтаны и пруды'] },
        ],
      },
      interieur: {
        breadcrumb: 'Дизайн интерьера',
        heroLabel:  'Дизайн интерьера',
        heroTitle1: 'Интерьеры',
        heroTitleItalic: 'по линеечке',
        heroSubtitle: 'Интерьер, который работает, прежде чем стать красивым. Столярные изделия на заказ, покрытия, выбранные поставщик за поставщиком, ненавязчивая автоматика: мы работаем над деталями, потому что именно с ними живут каждый день.',
        heroCta:    'Проектировать мой интерьер',
        featuresLabel: 'Наши преимущества',
        featuresTitle: 'Внимание к деталям',
        roomsLabel:  'Наши предложения',
        roomsTitle:  'Помещения на заказ',
        galleryLabel: 'Наши работы',
        galleryTitle: 'Несколько идей',
        ctaSubtitle: 'Бесплатная консультация по дизайну. Принесите свои референсы, обсудим вместе.',
        services: [
          { title: 'Столярные изделия на заказ', description: 'Двери, окна, шкафы и гардеробные, спроектированы и изготовлены для Вашего интерьера, комната за комнатой.', items: ['Массив и МДФ', 'Современный или классический дизайн', 'Лакированные или натуральные поверхности'] },
          { title: 'Покрытия премиум-класса',   description: 'Полы, стены и потолки из благородных материалов, выбранных надолго.', items: ['Массивный и инженерный паркет', 'Натуральный камень и плитка', 'Декоративные штукатурки'] },
          { title: 'Интегрированная автоматика',description: 'Управляемые системы для комфорта и безопасности, встроенные так, чтобы не перегружать пространство визуально.', items: ['Автоматизированное освещение', 'Зонированный климат-контроль', 'Подключённая безопасность'] },
          { title: 'Отделка высокого класса',   description: 'Со временем разницу делают именно детали: чистые стыки, незаметные переходы, краска без брака.', items: ['Экологические краски', 'Лепные украшения', 'Архитектурное освещение'] },
        ],
        rooms: [
          { name: 'Кухни',       desc: 'Итальянский дизайн, профессиональная техника' },
          { name: 'Ванные',      desc: 'Домашний спа, дизайнерская сантехника' },
          { name: 'Гардеробные', desc: 'Организация на заказ, встроенное освещение' },
          { name: 'Лестницы',    desc: 'Дерево, металл или стекло, в зависимости от проекта' },
        ],
      },
      maconnerie: {
        breadcrumb: 'Каменная кладка',
        heroLabel:  'Каменная кладка',
        heroTitle1: 'Искусство',
        heroTitleItalic: 'камня',
        heroSubtitle: 'Наша бригада каменщиков работает с камнем так, как это всегда делалось в регионе, сегодняшними инструментами. Природный камень, каталонские своды, известковые штукатурки: ремесло, которое передаётся на объектах, а не в брошюрах.',
        heroCta:    'Обсудить мой проект',
        techniquesLabel: 'Наши предложения',
        techniquesTitle: 'Традиционные техники',
        servicesLabel:   'Наши преимущества',
        servicesTitle:   'От фундамента до отделки',
        commitmentTitle: 'Наши обязательства',
        commitmentDesc:  'Наши работы по кладке ведут наши штатные бригады, обученные традиционным каталонским техникам и действующим нормам.',
        ctaSubtitle: 'Бесплатная консультация, детальная смета. Наши бригады выезжают, чтобы изучить Ваш проект.',
        techniques: [
          { title: 'Природный камень',   description: 'Сухая кладка, облицовка, opus incertum. Мы работаем с местными камнями провинции Girona, поставляемыми с карьеров, которые мы знаем.' },
          { title: 'Каталонские своды',  description: 'Техника кладки кирпича плашмя, отличительный знак средиземноморской архитектуры. Немногие бригады ещё ею владеют, наша владеет.' },
          { title: 'Декоративный бетон', description: 'Полированный, штампованный и промытый бетон для полов и невысоких стен.' },
        ],
        services: ['Фундамент и несущая конструкция', 'Несущие стены и перегородки', 'Каменные лестницы', 'Камины и мангалы', 'Подпорные стенки и ограждения', 'Реставрация фасадов', 'Традиционные штукатурки', 'Расшивка открытой каменной кладки'],
        commitments: ['Материалы местного происхождения там, где это возможно', 'Уважение к традиционным каталонским техникам', 'Десятилетняя гарантия на все наши работы'],
      },
      piscine: {
        breadcrumb: 'Бассейны',
        heroLabel:  'Бассейны',
        heroTitle1: 'Искусство',
        heroTitleItalic: 'воды',
        heroSubtitle: 'Бассейны, нарисованные так, чтобы вписаться в участок и дом, а не оказаться поверх них. От первого эскиза до технического оснащения мы ведём весь объект.',
        heroCta:    'Спроектировать мой бассейн',
        featuresLabel: 'Наши преимущества',
        featuresTitle: 'Технологии & Дизайн',
        typesLabel:  'Наши предложения',
        typesTitle:  'Выберите свой стиль',
        galleryLabel: 'Наши работы',
        galleryTitle: 'Избранные проекты',
        ctaSubtitle: 'Бесплатное технико-экономическое обоснование. Анализируем Ваш участок и Ваши пожелания.',
        features: [
          { title: 'Бассейн инфинити',     description: 'Зеркальный эффект, вписанный в средиземноморский пейзаж и откалиброванный под Ваш вид.' },
          { title: 'Солнечный обогрев',    description: 'Чтобы продлить сезон купаний, не утяжеляя счета за энергию.' },
          { title: 'Природная обработка',  description: 'Альтернативы хлору: соль, УФ или биологические бассейны для более мягкой воды.' },
          { title: 'Полная автоматизация', description: 'Фильтрация, обогрев, освещение управляются с телефона.' },
        ],
        types: [
          { title: 'Традиционный бассейн', desc: 'Железобетонная конструкция, индивидуальные размеры, плитка или плёнка.', size: '8×4 м' },
          { title: 'Бассейн инфинити',     desc: 'Зеркальный эффект и визуальное продолжение пейзажа.', size: '10×5 м' },
          { title: 'Биологический бассейн',desc: 'Природный водоём с зоной растительной регенерации.', size: '12×6 м' },
        ],
      },
    },
  },
};

// ─── Context ──────────────────────────────────────────────────────────────────

const LanguageContext = createContext(null);

const SUPPORTED_LANGS = ['fr', 'en', 'de', 'es', 'ru'];

export const LanguageProvider = ({ children }) => {
  // Public-site language.
  // Priority: ?lang= query param (deep-linking from hreflang) > localStorage > 'fr'.
  const [language, setLanguageState] = useState(() => {
    try {
      const urlLang = new URLSearchParams(window.location.search).get('lang');
      if (urlLang && SUPPORTED_LANGS.includes(urlLang)) {
        try { localStorage.setItem('remalex-lang', urlLang); } catch {}
        return urlLang;
      }
      const stored = localStorage.getItem('remalex-lang');
      if (stored && SUPPORTED_LANGS.includes(stored)) return stored;
      return 'fr';
    } catch {
      return 'fr';
    }
  });

  // Admin/back-office language — EN by default, switchable to FR/DE
  const [adminLanguage, setAdminLanguageState] = useState(() => {
    try {
      return localStorage.getItem('remalex-admin-lang') || 'en';
    } catch {
      return 'en';
    }
  });

  const setLanguage = (lang) => {
    if (translations[lang]) {
      setLanguageState(lang);
      try { localStorage.setItem('remalex-lang', lang); } catch {}
    }
  };

  const setAdminLanguage = (lang) => {
    // Admin only supports en/fr/de
    if (['en', 'fr', 'de'].includes(lang)) {
      setAdminLanguageState(lang);
      try { localStorage.setItem('remalex-admin-lang', lang); } catch {}
    }
  };

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  const t = translations[language] || translations.fr;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, adminLanguage, setAdminLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within a LanguageProvider');
  return ctx;
};

export default LanguageContext;
